  (function() {
    var root = document.getElementById('ppu-main');
    var modal = document.getElementById('ppu-modal-main');
    if (!root || !modal) return;

    // Portal modal to <body> so position:fixed escapes ancestor stacking contexts
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    // ===== refs =====
    var openBtn = root.querySelector('[data-open]');
    var fileInput = root.querySelector('.ppu__input');
    var triggerStrip = root.querySelector('[data-trigger-strip]');
    var triggerTitle = root.querySelector('[data-trigger-title]');
    var errorEl = root.querySelector('[data-error]');

    var slotsEl = modal.querySelector('[data-slots]');
    var slotBar = modal.querySelector('[data-slot-bar]');
    var applyAllBtn = modal.querySelector('[data-apply-all]') || { addEventListener: function(){}, classList: { add: function(){}, remove: function(){} }, disabled: false };
    var applyAllLabel = modal.querySelector('[data-apply-all-label]') || { textContent: '' };
    var stage = modal.querySelector('[data-stage]');
    var card = stage; // measurement reference: the stage itself is the card area
    var img = modal.querySelector('[data-img]');
    var placeholderText = modal.querySelector('[data-placeholder-text]');
    var zoom = modal.querySelector('[data-zoom]');
    var zoomVal = modal.querySelector('[data-zoom-val]');
    var sat = modal.querySelector('[data-sat]');
    var satVal = modal.querySelector('[data-sat-val]');
    var rotR = modal.querySelector('[data-rot-right]');
    var flipBtn = modal.querySelector('[data-flip]');
    var resetBtn = modal.querySelector('[data-reset]') || { addEventListener: function(){} };
    var saveBtn = modal.querySelector('[data-save]');
    var uploadNewBtn = modal.querySelector('[data-upload-new]');
    var uploadLabel = modal.querySelector('[data-upload-label]');
    var closeBtns = modal.querySelectorAll('[data-close]');

    var MAX_SLOTS = 12;
    var MAX_BYTES = 15 * 1024 * 1024;
    var defaults = { tx: 0, ty: 0, sc: 1, rot: 0, flip: 1, sat: 20 };

    // ===== i18n =====
    // Strings come from window.PPU_I18N (populated by the snippet's Liquid `t`
    // filter). Falls back to English defaults if a key is missing.
    var I18N_DEFAULTS = {
      trigger_upload: 'Upload Image',
      trigger_edit: 'Edit Designs',
      processing_label: 'Processing your designs…',
      processing_with_count: 'Processing your designs… {{ done }}/{{ total }}',
      almost_done: 'Almost done…',
      err_designs_required: 'Please design all your cards before adding to cart.',
      err_image_invalid: 'Please upload an image file.',
      err_image_too_large: 'Image too large. Max 15MB.',
      err_atc_failed: 'Could not add to cart. Please try again.',
      modal_placeholder: 'Upload an image to start designing this card',
      modal_placeholder_card_n: 'Upload an image for card {{ n }}',
      apply_all_label: 'Use this design for all {{ n }} cards',
      apply_all_done: 'Applied to all {{ n }} cards',
      upload_image: 'Upload image',
      change_image: 'Change image',
      save_designs: 'Save designs',
      save_more_needed_one: '1 more design needed',
      save_more_needed_other: '{{ n }} more designs needed',
      tool_rotate: 'Rotate',
      tool_flip: 'Flip',
      tool_reset: 'Reset',
      zoom: 'Zoom',
      saturation: 'Saturation'
    };
    function t(key, vars) {
      var s = (window.PPU_I18N && window.PPU_I18N[key]) || I18N_DEFAULTS[key] || key;
      if (vars) {
        for (var k in vars) {
          if (Object.prototype.hasOwnProperty.call(vars, k)) {
            s = s.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), String(vars[k]));
          }
        }
      }
      return s;
    }

    // ===== SUPABASE EDGE FUNCTION PROXY ===========================================
    // The Edge Function proxies file uploads from browser → Shopify Files API.
    // Files end up on cdn.shopify.com (Shopify's storage, your normal Files admin).
    // Supabase just orchestrates — it never stores the file.
    //
    // Edge Function: pp-upload-design
    //   POST <function_url> with multipart {file}
    //   Returns: { url: "https://cdn.shopify.com/s/files/.../files/...jpg" }
    var PPU_UPLOAD = (window.PPU_UPLOAD) || {
      url:    '',  // e.g. 'https://kbmuathinalmrtlkwbkb.supabase.co/functions/v1/pp-upload-design'
      anonKey: ''  // Supabase publishable key (needed for Edge Function auth)
    };
    var PPU_UPLOAD_ENABLED = !!(PPU_UPLOAD.url && PPU_UPLOAD.anonKey);

    function uploadDesign(blob, filename) {
      if (!PPU_UPLOAD_ENABLED) return Promise.reject(new Error('upload proxy not configured'));
      var fd = new FormData();
      fd.append('file', blob, filename || 'design.jpg');
      return fetch(PPU_UPLOAD.url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + PPU_UPLOAD.anonKey,
          'apikey': PPU_UPLOAD.anonKey
        },
        body: fd
      }).then(function(r) {
        if (!r.ok) {
          return r.text().catch(function() { return ''; }).then(function(t) {
            throw new Error('Upload proxy failed (' + r.status + '): ' + t.slice(0, 200));
          });
        }
        return r.json();
      }).then(function(data) {
        if (!data || !data.url) throw new Error('Upload proxy returned no URL');
        return data.url;
      });
    }

    // ===== state =====
    var slots = new Array(MAX_SLOTS).fill(null); // each: { dataURL, fileName, tx, ty, sc, rot, flip, sat }
    var activeSlot = 0;
    var working = blankSlot();
    var currentQty = readQty();

    function blankSlot() {
      return { dataURL: '', fileName: '', tx: defaults.tx, ty: defaults.ty, sc: defaults.sc, rot: defaults.rot, flip: defaults.flip, sat: defaults.sat };
    }

    function readQty() {
      var active = document.querySelector('.pp-tier-row .t.active') || document.querySelector('.pp-qty-btn.active');
      if (!active) return 1;
      var q = parseInt(active.getAttribute('data-stickers') || active.getAttribute('data-qty'), 10);
      return Math.max(1, Math.min(MAX_SLOTS, q || 1));
    }

    var __ppErrorTimer = null;
    function clearError() {
      errorEl.textContent = '';
      root.classList.remove('has-error');
      if (__ppErrorTimer) { clearTimeout(__ppErrorTimer); __ppErrorTimer = null; }
    }
    function setError(m, autoHideMs) {
      errorEl.textContent = m;
      root.classList.add('has-error');
      if (__ppErrorTimer) { clearTimeout(__ppErrorTimer); __ppErrorTimer = null; }
      var hide = (typeof autoHideMs === 'number') ? autoHideMs : 5000;
      if (hide > 0) {
        __ppErrorTimer = setTimeout(clearError, hide);
      }
    }
    function clearError() { root.classList.remove('has-error'); errorEl.textContent = ''; }

    // ===== cover math (clamp) =====
    function coverFit(iw, ih, dstW, dstH, rotDeg) {
      // Compute pre-rotation rendered dimensions so the image covers dstW x dstH after rotation
      var quarter = Math.round(((rotDeg % 360) + 360) % 360 / 90) % 4;
      var swap = (quarter === 1 || quarter === 3);
      var effW = swap ? dstH : dstW;
      var effH = swap ? dstW : dstH;
      var imgA = iw / ih, cardA = effW / effH;
      var rW, rH;
      if (imgA > cardA) { rH = effH; rW = effH * imgA; } else { rW = effW; rH = effW / imgA; }
      return { rW: rW, rH: rH };
    }
    function getRendered() {
      var cW = card.clientWidth || 1, cH = card.clientHeight || 1;
      var iw = img.naturalWidth || 1, ih = img.naturalHeight || 1;
      var f = coverFit(iw, ih, cW, cH, working.rot);
      return { cW: cW, cH: cH, rW: f.rW, rH: f.rH };
    }
    function applyImageSize() {
      var d = getRendered();
      img.style.setProperty('--iw', d.rW + 'px');
      img.style.setProperty('--ih', d.rH + 'px');
    }
    function clampWorking() {
      if (!img.naturalWidth) return;
      var d = getRendered();
      var quarter = Math.round(((working.rot % 360) + 360) % 360 / 90) % 4;
      var swap = (quarter === 1 || quarter === 3);
      var fW = swap ? d.rH : d.rW;
      var fH = swap ? d.rW : d.rH;
      var minSc = Math.max(d.cW / fW, d.cH / fH, 1);
      if (working.sc < minSc) working.sc = minSc;
      if (working.sc > 4) working.sc = 4;
      var maxTx = Math.max(0, (fW * working.sc - d.cW) / 2);
      var maxTy = Math.max(0, (fH * working.sc - d.cH) / 2);
      if (working.tx > maxTx) working.tx = maxTx;
      if (working.tx < -maxTx) working.tx = -maxTx;
      if (working.ty > maxTy) working.ty = maxTy;
      if (working.ty < -maxTy) working.ty = -maxTy;
    }
    function applyTransform() {
      clampWorking();
      img.style.setProperty('--tx', working.tx + 'px');
      img.style.setProperty('--ty', working.ty + 'px');
      img.style.setProperty('--sc', working.sc);
      img.style.setProperty('--rot', working.rot + 'deg');
      img.style.setProperty('--flip', working.flip);
      img.style.setProperty('--sat', (1 + working.sat / 100).toFixed(3));
      var zoomPct = Math.round(((working.sc - 1) / 3) * 100);
      zoomVal.textContent = zoomPct + '%';
      satVal.textContent = (working.sat >= 0 ? '+' : '') + Math.round(working.sat);
      zoom.value = zoomPct;
      sat.value = Math.round(working.sat);
      scheduleLiveThumb();
    }

    // Live-update the active slot thumbnail when transforms change
    var liveThumbTimer = null;
    function scheduleLiveThumb() {
      if (!working.dataURL) return;
      clearTimeout(liveThumbTimer);
      liveThumbTimer = setTimeout(function() {
        var snapshot = {
          dataURL: working.dataURL, tx: working.tx, ty: working.ty,
          sc: working.sc, rot: working.rot, flip: working.flip, sat: working.sat
        };
        bakeThumb(snapshot, function(dataUrl) {
          if (!dataUrl) return;
          // Update the active slot's thumb in state and in the DOM (no full re-render)
          if (slots[activeSlot]) slots[activeSlot].thumb = dataUrl;
          var slotEls = slotsEl.children;
          if (slotEls[activeSlot]) {
            var imgEl = slotEls[activeSlot].querySelector('img');
            if (imgEl) imgEl.src = dataUrl;
          }
        });
      }, 140);
    }

    // ===== slot management =====
    function commitWorkingToSlot() {
      if (!working.dataURL) return;

      /* Snapshot the OLD active-slot signature BEFORE overwriting so we can
         find duplicate sibling slots (same image + transforms) — they need
         to be synced when the active slot changes. */
      var prevSig = slotSignature(slots[activeSlot]);
      var siblingIdxs = [];
      if (prevSig) {
        for (var si = 0; si < currentQty; si++) {
          if (si === activeSlot) continue;
          if (slotSignature(slots[si]) === prevSig) siblingIdxs.push(si);
        }
      }

      var prevThumb = slots[activeSlot] && slots[activeSlot].thumb;
      var newSlot = {
        dataURL: working.dataURL, fileName: working.fileName,
        tx: working.tx, ty: working.ty, sc: working.sc, rot: working.rot,
        flip: working.flip, sat: working.sat,
        previewW: card.clientWidth || 760,
        originalFile: working.originalFile,
        thumb: prevThumb || ''
      };
      slots[activeSlot] = newSlot;

      var newSig = slotSignature(newSlot);
      var didChange = newSig !== prevSig;
      var siblings = (siblingIdxs.length && didChange) ? siblingIdxs : [];

      /* Propagate new data to siblings (preserving their prior thumb as a
         placeholder until the per-slot bake completes). */
      siblings.forEach(function(j) {
        var sibPrevThumb = slots[j] && slots[j].thumb;
        slots[j] = {
          dataURL: newSlot.dataURL,
          fileName: newSlot.fileName,
          tx: newSlot.tx, ty: newSlot.ty, sc: newSlot.sc, rot: newSlot.rot,
          flip: newSlot.flip, sat: newSlot.sat,
          previewW: newSlot.previewW,
          originalFile: newSlot.originalFile,
          thumb: sibPrevThumb || ''
        };
      });

      /* FROZEN SNAPSHOT for baking — a literal copy of the slot fields so the
         bake's onload callback CANNOT read mutated values later (e.g. if the
         user kicks off another transform before this bake completes). Without
         this, the rotate-then-look-at-siblings case was racing with subsequent
         applyTransform calls and the canvas was rendering stale rotation. */
      function snap(s) {
        return {
          dataURL: s.dataURL,
          tx: s.tx, ty: s.ty, sc: s.sc, rot: s.rot,
          flip: s.flip, sat: s.sat,
          previewW: s.previewW
        };
      }

      var indicesToBake = [activeSlot].concat(siblings);
      var bakeSnap = snap(newSlot);

      // ALL slots that share this state get an independent thumb bake from the
      // SAME frozen snapshot. Each bake assigns its result to its own slot when
      // done, then triggers a renderSlots so the strip updates immediately.
      indicesToBake.forEach(function(idx) {
        bakeThumb(bakeSnap, function(dataUrl) {
          if (!dataUrl || !slots[idx]) return;
          // Only apply if the slot still holds the same signature — otherwise
          // a newer commit has superseded this bake and its result is stale.
          if (slotSignature(slots[idx]) !== newSig) return;
          slots[idx].thumb = dataUrl;
          if (modal.classList.contains('is-open')) renderSlots();
        });
        bakeLargePreview(bakeSnap, function(dataUrl) {
          if (!dataUrl || !slots[idx]) return;
          if (slotSignature(slots[idx]) !== newSig) return;
          slots[idx].largePreview = dataUrl;
        });
      });

      // Print blob + Cloudinary upload — bake once, broadcast result to siblings
      var targetSig = newSig;
      slots[activeSlot].printSig = targetSig;
      slots[activeSlot].printBlob = null;
      slots[activeSlot].uploadedURL = null;
      slots[activeSlot].uploadSig = null;
      siblings.forEach(function(j) {
        if (slots[j]) {
          slots[j].printSig = targetSig;
          slots[j].printBlob = null;
          slots[j].uploadedURL = null;
          slots[j].uploadSig = null;
        }
      });

      bakeSlot(slots[activeSlot], function(blob) {
        if (!blob || !slots[activeSlot]) return;
        if (slots[activeSlot].printSig !== targetSig) return;
        slots[activeSlot].printBlob = blob;
        siblings.forEach(function(j) {
          if (slots[j] && slots[j].printSig === targetSig) {
            slots[j].printBlob = blob;
          }
        });
        if (PPU_UPLOAD_ENABLED) {
          var fname = (slots[activeSlot].fileName || 'design').replace(/\.[^.]+$/, '') + '_' + (activeSlot + 1) + '.jpg';
          uploadDesign(blob, fname).then(function(shopifyURL) {
            if (slots[activeSlot] && slots[activeSlot].printSig === targetSig) {
              slots[activeSlot].uploadedURL = shopifyURL;
              slots[activeSlot].uploadSig = targetSig;
            }
            siblings.forEach(function(j) {
              if (slots[j] && slots[j].printSig === targetSig) {
                slots[j].uploadedURL = shopifyURL;
                slots[j].uploadSig = targetSig;
              }
            });
          }).catch(function(err) {
            try { console.warn('[ppu] background upload failed', err); } catch (e) {}
          });
        }
      });
    }
    function bakeThumb(slot, callback) { bakeThumbAtSize(slot, 256, 0.82, callback); }
    // 700px is plenty for cart thumbs (max ~96px display) AND product gallery
    // (max ~700px display) — drops file size ~4x vs the old 1200px.
    function bakeLargePreview(slot, callback) { bakeThumbAtSize(slot, 700, 0.85, callback); }
    function bakeThumbAtSize(slot, W, quality, callback) {
      if (!slot || !slot.dataURL || slot.dataURL.length < 200) return callback('');
      var tempImg = new Image();
      tempImg.onerror = function() { callback(''); };
      tempImg.onload = function() {
        if (!tempImg.naturalWidth || !tempImg.naturalHeight) return callback('');
        try {
          var H = Math.round(W * 54 / 86);
          var cv = document.createElement('canvas');
          cv.width = W; cv.height = H;
          var ctx = cv.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          // Use the snapshot taken at commit time — falls back to live width
          // only as a last resort (modal still open during this call).
          var previewW = slot.previewW || card.clientWidth || 760;
          var k = W / previewW;
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, W, H);
          ctx.save();
          // NO ctx.filter — applies saturation via fast pixel pass instead
          ctx.translate(W / 2 + slot.tx * k, H / 2 + slot.ty * k);
          ctx.scale(slot.flip, 1);
          ctx.rotate(slot.rot * Math.PI / 180);
          ctx.scale(slot.sc, slot.sc);
          var iw = tempImg.naturalWidth, ih = tempImg.naturalHeight;
          var f = coverFit(iw, ih, W, H, slot.rot);
          ctx.drawImage(tempImg, -f.rW / 2, -f.rH / 2, f.rW, f.rH);
          ctx.restore();
          // Apply saturation (small canvas, fast — 700px max)
          if (slot.sat && slot.sat !== 0) {
            try {
              var satFactor = 1 + slot.sat / 100;
              var oneMinus = 1 - satFactor;
              var rW2 = 0.2989 * oneMinus, gW2 = 0.587 * oneMinus, bW2 = 0.114 * oneMinus;
              var imgData = ctx.getImageData(0, 0, W, H);
              var d = imgData.data;
              var len = d.length;
              for (var pi = 0; pi < len; pi += 4) {
                var r = d[pi], g = d[pi + 1], b = d[pi + 2];
                var grayContrib = rW2 * r + gW2 * g + bW2 * b;
                d[pi]     = satFactor * r + grayContrib;
                d[pi + 1] = satFactor * g + grayContrib;
                d[pi + 2] = satFactor * b + grayContrib;
              }
              ctx.putImageData(imgData, 0, 0);
            } catch (e) {}
          }
          // Chip cutout - matches the on-screen overlay (ISO/IEC 7816-2 centered position)
          var cx = W * 0.1285, cy = H * 0.3677, cw = W * 0.129, ch = H * 0.167;
          var rTL = Math.min(cw, ch) * 0.14;
          ctx.fillStyle = '#FFFFFF';
          ctx.beginPath();
          ctx.moveTo(cx + rTL, cy);
          ctx.arcTo(cx + cw, cy, cx + cw, cy + ch, rTL);
          ctx.arcTo(cx + cw, cy + ch, cx, cy + ch, rTL);
          ctx.arcTo(cx, cy + ch, cx, cy, rTL);
          ctx.arcTo(cx, cy, cx + cw, cy, rTL);
          ctx.closePath();
          ctx.fill();
          callback(cv.toDataURL('image/jpeg', quality || 0.82));
        } catch (err) {
          callback('');
        }
      };
      tempImg.src = slot.dataURL;
    }
    function loadSlotIntoEditor(idx) {
      activeSlot = idx;
      var s = slots[idx];
      if (s && s.dataURL) {
        working = { dataURL: s.dataURL, fileName: s.fileName, tx: s.tx, ty: s.ty, sc: s.sc, rot: s.rot, flip: s.flip, sat: s.sat };
        img.onload = function() {
          applyImageSize();
          applyTransform();
          stage.classList.add('has-img');
          stage.classList.remove('is-empty');
          uploadLabel.textContent = t('change_image');
        };
        img.src = working.dataURL;
      } else {
        working = blankSlot();
        img.src = '';
        stage.classList.remove('has-img');
        stage.classList.add('is-empty');
        uploadLabel.textContent = t('upload_image');
      }
      placeholderText.textContent = t('upload_image');
      updateSaveBtn();
      /* Refresh qty stepper for the newly-active slot (enable/disable buttons,
         update count to reflect how many copies of this design exist). */
      if (typeof refreshQtyStepper === 'function') refreshQtyStepper();
    }
    function renderSlots() {
      slotsEl.innerHTML = '';
      slotBar.setAttribute('data-qty', currentQty);
      // Apply-all button only useful when active slot has an image and qty > 1
      var hasActiveImg = working.dataURL || (slots[activeSlot] && slots[activeSlot].dataURL);
      applyAllBtn.disabled = !hasActiveImg || currentQty < 2;
      applyAllLabel.textContent = t('apply_all_label', { n: currentQty });
      updateSaveBtn();
      updateAtcBtn();
      for (var i = 0; i < currentQty; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ppu-slot';
        var hasImg = slots[i] && slots[i].dataURL;
        if (hasImg) btn.classList.add('has-img');
        if (i === activeSlot) btn.classList.add('is-active');
        btn.setAttribute('data-slot-idx', i);

        if (hasImg) {
          var imgEl = document.createElement('img');
          imgEl.src = slots[i].thumb || slots[i].dataURL;
          btn.appendChild(imgEl);
        } else {
          var plus = document.createElement('span');
          plus.className = 'ppu-slot__plus';
          plus.textContent = '+';
          btn.appendChild(plus);
        }
        var num = document.createElement('span');
        num.className = 'ppu-slot__num';
        num.textContent = i + 1;
        btn.appendChild(num);

        var chk = document.createElement('span');
        chk.className = 'ppu-slot__check';
        chk.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
        btn.appendChild(chk);

        btn.addEventListener('click', (function(idx) {
          return function() {
            commitWorkingToSlot();
            loadSlotIntoEditor(idx);
            renderSlots();
            // Switching to an empty slot: auto-open the file picker, same as openModal's default-slot behavior
            if (!slots[idx] || !slots[idx].dataURL) {
              setTimeout(function() { fileInput.click(); }, 80);
            }
          };
        })(i));

        slotsEl.appendChild(btn);
      }
    }
    function countFilled() {
      var n = 0;
      for (var i = 0; i < currentQty; i++) if (slots[i] && slots[i].dataURL) n++;
      return n;
    }
    function updateSaveBtn() {
      // Save is always available — user may add to cart with fewer designs than
      // the chosen quantity and the remaining slots are sent empty.
      saveBtn.disabled = false;
      saveBtn.textContent = t('save_designs');
    }
    function updateAtcBtn() {
      var ppuRoot = document.querySelector('.ppu');
      var isRequired = !ppuRoot || ppuRoot.getAttribute('data-required') !== 'false';
      var addBtns = document.querySelectorAll('product-form [name="add"], form[action*="/cart/add"] [name="add"], .product-form__submit');
      if (!isRequired) {
        addBtns.forEach(function(btn) {
          if (btn.getAttribute('data-ppu-locked') === '1') {
            btn.disabled = false;
            btn.removeAttribute('data-ppu-locked');
          }
        });
        return;
      }
      var complete = countFilled() >= currentQty;
      addBtns.forEach(function(btn) {
        if (!complete) {
          if (!btn.disabled || btn.getAttribute('data-ppu-locked') === '1') {
            btn.disabled = true;
            btn.setAttribute('data-ppu-locked', '1');
          }
        } else {
          if (btn.getAttribute('data-ppu-locked') === '1') {
            btn.disabled = false;
            btn.removeAttribute('data-ppu-locked');
          }
        }
      });
    }

    // ===== file handling =====
    // ===== Image normalization (iOS-safe pipeline) =====
    // iOS Safari/WebKit silently truncates or fails canvas operations on images
    // above ~5 megapixels (12MP+ iPhone photos hit this every time). The fix:
    // normalize every uploaded image to a safe size (max 2048px on longest edge)
    // and re-export as JPEG before any other canvas work touches it.
    // This single step:
    //   - Fixes the iOS white-bake bug (sources are always small enough)
    //   - Converts HEIC → JPEG (iOS Safari can decode HEIC to canvas; output is JPEG)
    //   - Applies EXIF orientation (Image element rendering honors EXIF, canvas
    //     re-export bakes the orientation in)
    //   - Sheds metadata bloat (12MP HEIC → ~500KB JPEG)
    function normalizeImageDataURL(rawDataURL) {
      return new Promise(function(resolve, reject) {
        var probe = new Image();
        probe.onerror = function() { reject(new Error('Could not decode image')); };
        probe.onload = function() {
          var iw = probe.naturalWidth, ih = probe.naturalHeight;
          if (!iw || !ih) return reject(new Error('Image has no dimensions'));
          // Wait for the decoder to finish before using the image
          var ready = (typeof probe.decode === 'function')
            ? probe.decode().catch(function() { return null; })
            : Promise.resolve();
          ready.then(function() {
            // 2560px max keeps source under iOS 5MP decoded image cap while
            // giving the 2400px bake target plenty of source detail.
            var MAX = 2560;
            var scale = Math.min(1, MAX / iw, MAX / ih);
            var nw = Math.max(1, Math.round(iw * scale));
            var nh = Math.max(1, Math.round(ih * scale));
            try {
              var cv = document.createElement('canvas');
              cv.width = nw; cv.height = nh;
              var ctx = cv.getContext('2d');
              if (!ctx) return reject(new Error('canvas context unavailable'));
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = 'high';
              ctx.fillStyle = '#FFFFFF';
              ctx.fillRect(0, 0, nw, nh);
              ctx.drawImage(probe, 0, 0, nw, nh);
              // Verify the draw actually worked — sample center pixel.
              // Pure-white center is suspicious for non-white photos but we can't
              // reliably detect "should not be white"; instead rely on toDataURL
              // size threshold below as a fallback.
              var out = cv.toDataURL('image/jpeg', 0.92);
              if (!out || out.length < 5000) {
                // toDataURL produced empty/tiny output — the iOS canvas memory
                // issue. Try once more with a smaller target.
                var smW = Math.max(1, Math.round(nw * 0.7));
                var smH = Math.max(1, Math.round(nh * 0.7));
                var cv2 = document.createElement('canvas');
                cv2.width = smW; cv2.height = smH;
                var ctx2 = cv2.getContext('2d');
                ctx2.imageSmoothingEnabled = true;
                ctx2.imageSmoothingQuality = 'high';
                ctx2.fillStyle = '#FFFFFF';
                ctx2.fillRect(0, 0, smW, smH);
                ctx2.drawImage(probe, 0, 0, smW, smH);
                out = cv2.toDataURL('image/jpeg', 0.9);
                if (!out || out.length < 5000) {
                  return reject(new Error('canvas produced empty output (iOS memory limit?)'));
                }
              }
              resolve({ dataURL: out, width: nw, height: nh });
            } catch (err) {
              reject(err);
            }
          });
        };
        probe.src = rawDataURL;
      });
    }

    function handleFile(file) {
      clearError();
      if (!file) return;
      // Accept HEIC files (iPhone default) — type may be 'image/heic' or empty
      if (file.type && !file.type.match(/^image\//) && !/\.(heic|heif|jpe?g|png|webp)$/i.test(file.name)) {
        setError(t('err_image_invalid'));
        return;
      }
      if (file.size > MAX_BYTES) { setError(t('err_image_too_large')); return; }

      var reader = new FileReader();
      reader.onerror = function() { setError(t('err_image_invalid')); };
      reader.onload = function(e) {
        var rawDataURL = e.target.result;
        // Normalize FIRST — produces a safe-size JPEG dataURL that all
        // downstream canvas operations (bake, thumb, large preview) can
        // handle without hitting iOS limits.
        normalizeImageDataURL(rawDataURL).then(function(normalized) {
          working = blankSlot();
          working.dataURL = normalized.dataURL;
          working.fileName = file.name;
          // KEEP THE ORIGINAL FILE for 100% quality upload to admin.
          // The normalized dataURL drives previews/editing only — the raw
          // file goes to Shopify Custom Image so admin gets the customer's
          // EXACT original bytes (no re-encoding, no downscale).
          working.originalFile = file;
          img.onload = function() {
            // Auto-rotate portrait images 270° so they fit landscape card
            if (img.naturalHeight > img.naturalWidth) {
              working.rot = 270;
            }
            applyImageSize();
            applyTransform();
            stage.classList.add('has-img');
            stage.classList.remove('is-empty');
            uploadLabel.textContent = t('change_image');
            commitWorkingToSlot();
            renderSlots();
            refreshQtyStepper();
          };
          img.src = working.dataURL;
        }).catch(function(err) {
          try { console.warn('[ppu] normalizeImage failed:', err); } catch (_) {}
          setError(t('err_image_invalid'));
        });
      };
      reader.readAsDataURL(file);
    }

    // ===== modal open/close =====
    function openModal(targetSlot) {
      currentQty = readQty();
      if (typeof targetSlot !== 'number') {
        // Default: first empty slot, or 0 if all filled
        targetSlot = 0;
        for (var i = 0; i < currentQty; i++) {
          if (!slots[i] || !slots[i].dataURL) { targetSlot = i; break; }
          if (i === currentQty - 1) targetSlot = 0;
        }
      }
      renderSlots();
      loadSlotIntoEditor(targetSlot);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ppu-modal-open');

      // If the active slot has no image, auto-open file picker
      if (!slots[targetSlot] || !slots[targetSlot].dataURL) {
        setTimeout(function() { fileInput.click(); }, 80);
      }
    }
    function closeModal() {
      commitWorkingToSlot();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ppu-modal-open');
      bakeAndUpdateInputs();
      updateTrigger();
    }
    function saveAndClose() {
      // Plain save: commit the editor state to the active slot and close.
      // No auto-advance to remaining empty slots.
      commitWorkingToSlot();
      closeModal();
    }

    // ===== bake + sync hidden file inputs =====
    function ensureCartInputs() {
      // Two inputs per slot: print file (no chip) and preview thumb (with chip)
      root.querySelectorAll('input.ppu-cart-input, input.ppu-preview-input').forEach(function(i) { i.remove(); });
      for (var i = 0; i < currentQty; i++) {
        var printInp = document.createElement('input');
        printInp.type = 'file';
        printInp.className = 'ppu-cart-input';
        printInp.name = 'properties[Custom Image ' + (i + 1) + ']';
        printInp.setAttribute('accept', 'image/png,image/jpeg');
        printInp.style.cssText = 'display:none !important;position:absolute;left:-9999px;width:0;height:0;opacity:0;pointer-events:none;';
        root.appendChild(printInp);

        var previewInp = document.createElement('input');
        previewInp.type = 'file';
        previewInp.className = 'ppu-preview-input';
        // Underscore prefix → hidden from customer in cart/checkout, visible to merchant in admin
        previewInp.name = 'properties[_Preview ' + (i + 1) + ']';
        previewInp.setAttribute('accept', 'image/png,image/jpeg');
        previewInp.style.cssText = 'display:none !important;position:absolute;left:-9999px;width:0;height:0;opacity:0;pointer-events:none;';
        root.appendChild(previewInp);
      }
    }
    function dataUrlToFile(dataUrl, filename) {
      var arr = dataUrl.split(',');
      var mimeMatch = arr[0].match(/:(.*?);/);
      var mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
      var binary = atob(arr[1]);
      var n = binary.length;
      var u8 = new Uint8Array(n);
      while (n--) u8[n] = binary.charCodeAt(n);
      return new File([u8], filename, { type: mime });
    }
    function drawChipCutout(ctx, W, H) {
      var chipX = W * 0.1285, chipY = H * 0.3677, chipW = W * 0.129, chipH = H * 0.167;
      var r = Math.min(chipW, chipH) * 0.14;
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.moveTo(chipX + r, chipY);
      ctx.lineTo(chipX + chipW - r, chipY);
      ctx.quadraticCurveTo(chipX + chipW, chipY, chipX + chipW, chipY + r);
      ctx.lineTo(chipX + chipW, chipY + chipH - r);
      ctx.quadraticCurveTo(chipX + chipW, chipY + chipH, chipX + chipW - r, chipY + chipH);
      ctx.lineTo(chipX + r, chipY + chipH);
      ctx.quadraticCurveTo(chipX, chipY + chipH, chipX, chipY + chipH - r);
      ctx.lineTo(chipX, chipY + r);
      ctx.quadraticCurveTo(chipX, chipY, chipX + r, chipY);
      ctx.closePath();
      ctx.fill();
    }
    // Cart-and-print bake: 1000×628 (86:54 card aspect, ≈297 DPI on 85.6mm card).
    // Uses new Image() + tempImg.decode() (the proven-working pattern on desktop)
    // with retry-on-too-small at the bake level to handle iOS Safari edge cases.
    function doSingleBake(slot, tempImg) {
      return new Promise(function(resolve) {
        try {
          // 2400×1508 = 712 DPI on an 85.6mm card — visually indistinguishable
          // from the customer's original on print. JPEG 0.95 below preserves
          // ~99% of perceived quality.
          var W = 2400, H = Math.round(W * 54 / 86);
          var iw = tempImg.naturalWidth, ih = tempImg.naturalHeight;
          if (!iw || !ih) return resolve(null);

          var cv = document.createElement('canvas');
          cv.width = W; cv.height = H;
          var ctx = cv.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          // Use the snapshot taken at commit time — modal stage clientWidth
          // returns 0 once the modal is closed, which would otherwise produce
          // a totally wrong k factor and broken transforms.
          var previewW = slot.previewW || card.clientWidth || 760;
          var k = W / previewW;

          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, W, H);
          ctx.save();
          ctx.translate(W / 2 + slot.tx * k, H / 2 + slot.ty * k);
          ctx.scale(slot.flip, 1);
          ctx.rotate(slot.rot * Math.PI / 180);
          ctx.scale(slot.sc, slot.sc);
          var f = coverFit(iw, ih, W, H, slot.rot);
          ctx.drawImage(tempImg, -f.rW / 2, -f.rH / 2, f.rW, f.rH);
          ctx.restore();

          if (slot.sat && slot.sat !== 0) {
            try {
              var satFactor = 1 + slot.sat / 100;
              var oneMinus = 1 - satFactor;
              var rW2 = 0.2989 * oneMinus, gW2 = 0.587 * oneMinus, bW2 = 0.114 * oneMinus;
              var imgData = ctx.getImageData(0, 0, W, H);
              var d = imgData.data;
              var len = d.length;
              for (var pi = 0; pi < len; pi += 4) {
                var r = d[pi], g = d[pi + 1], b = d[pi + 2];
                var grayContrib = rW2 * r + gW2 * g + bW2 * b;
                d[pi]     = satFactor * r + grayContrib;
                d[pi + 1] = satFactor * g + grayContrib;
                d[pi + 2] = satFactor * b + grayContrib;
              }
              ctx.putImageData(imgData, 0, 0);
            } catch (e) {}
          }

          cv.toBlob(function(blob) { resolve(blob); }, 'image/jpeg', 0.95);
        } catch (err) {
          try { console.warn('[ppu] doSingleBake threw:', err); } catch (e) {}
          resolve(null);
        }
      });
    }
    function loadImage(slot) {
      return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onerror = function() { reject(new Error('image load failed')); };
        img.onload = function() {
          if (!img.naturalWidth || !img.naturalHeight) return reject(new Error('no dimensions'));
          var p = (typeof img.decode === 'function') ? img.decode() : Promise.resolve();
          p.then(function() { resolve(img); }).catch(function() { resolve(img); });
        };
        img.src = slot.dataURL;
      });
    }
    function bakeSlot(slot, callback) {
      if (!slot || !slot.dataURL || slot.dataURL.length < 200) {
        try { console.warn('[ppu] bakeSlot called with invalid slot'); } catch (e) {}
        return callback(null);
      }
      // Up to 3 attempts. Each retry re-decodes the source — catches iOS Safari
      // race conditions where onload fires before pixel data is ready.
      var attempt = 0;
      function tryBake() {
        attempt++;
        loadImage(slot)
          .then(function(img) { return doSingleBake(slot, img); })
          .then(function(blob) {
            if (blob && blob.size >= 8000) {
              return callback(blob);
            }
            try { console.warn('[ppu] bake attempt ' + attempt + ' bad blob size:', blob && blob.size); } catch (e) {}
            if (attempt < 3) setTimeout(tryBake, 120 * attempt);
            else callback(null);
          })
          .catch(function(err) {
            try { console.warn('[ppu] bake attempt ' + attempt + ' failed:', err); } catch (e) {}
            if (attempt < 3) setTimeout(tryBake, 120 * attempt);
            else callback(null);
          });
      }
      tryBake();
    }
    function bakeAndUpdateInputs() {
      ensureCartInputs();
      var printInputs = root.querySelectorAll('input.ppu-cart-input');
      var previewInputs = root.querySelectorAll('input.ppu-preview-input');
      for (var i = 0; i < currentQty; i++) (function(idx) {
        var slot = slots[idx];
        var printInp = printInputs[idx];
        var previewInp = previewInputs[idx];
        if (!slot || !slot.dataURL) {
          if (printInp) printInp.value = '';
          if (previewInp) previewInp.value = '';
          return;
        }
        var baseName = (slot.fileName || 'design').replace(/\.[^.]+$/, '');

        // 1) Bake the print file (high-res, no chip) → factory file
        bakeSlot(slot, function(blob) {
          if (!blob || !printInp) return;
          var pf = new File([blob], baseName + '_print_' + (idx + 1) + '.jpg', { type: 'image/jpeg' });
          try {
            var dt = new DataTransfer();
            dt.items.add(pf);
            printInp.files = dt.files;
          } catch (e) {}
        });

        // 2) Attach the large preview (with chip) → cart drawer image + merchant reference
        var attachPreview = function(previewDataUrl) {
          if (!previewDataUrl || !previewInp) return;
          var pfile = dataUrlToFile(previewDataUrl, baseName + '_preview_' + (idx + 1) + '.jpg');
          try {
            var dt2 = new DataTransfer();
            dt2.items.add(pfile);
            previewInp.files = dt2.files;
          } catch (e) {}
        };
        if (slot.largePreview) {
          attachPreview(slot.largePreview);
        } else {
          bakeLargePreview(slot, function(previewDataUrl) {
            slot.largePreview = previewDataUrl;
            attachPreview(previewDataUrl);
          });
        }
      })(i);
      fileInput.setAttribute('data-current-file-qty', countFilled() > 0 ? '1' : '0');
    }

    // ===== trigger UI =====
    function updateTrigger() {
      var done = countFilled();
      root.classList.remove('is-partial', 'is-complete');
      if (done === 0) {
        triggerTitle.textContent = t('trigger_upload').toUpperCase();
        if (triggerStrip) triggerStrip.innerHTML = '';
        return;
      }
      if (done < currentQty) root.classList.add('is-partial');
      else root.classList.add('is-complete');

      if (!triggerStrip) return;
      triggerStrip.innerHTML = '';
      triggerStrip.setAttribute('data-qty', currentQty);

      // Always render ALL thumbs — no "+N" overflow indicator.
      // NOTE the variable is `th`, not `t`: `var` is function-scoped, so a
      // `var t` here hoists to the top of updateTrigger and shadows the t()
      // translate helper - which made line ~909 throw "t is not a function"
      // on every empty-state render and abort the whole trigger update.
      for (var i = 0; i < currentQty; i++) {
        var th = document.createElement('span');
        th.className = 'ppu__thumb-strip__thumb';
        var s = slots[i];
        if (s && (s.thumb || s.largePreview || s.dataURL)) {
          var im = document.createElement('img');
          im.src = s.thumb || s.largePreview || s.dataURL;
          im.alt = '';
          th.appendChild(im);
        } else {
          th.classList.add('ppu__thumb-strip__thumb--placeholder');
        }
        triggerStrip.appendChild(th);
      }
    }

    // ===== quantity sync =====
    function onQtyChange() {
      var newQty = readQty();
      if (newQty === currentQty) return;
      currentQty = newQty;
      if (activeSlot >= currentQty) {
        commitWorkingToSlot();
        loadSlotIntoEditor(0);
      }
      if (modal.classList.contains('is-open')) renderSlots();
      ensureCartInputs();
      bakeAndUpdateInputs();
      updateTrigger();
    }
    // Listen to BOTH the old .pp-qty-btn and the new .pp-tier-row .t buttons
    document.querySelectorAll('.pp-qty-btn, .pp-tier-row .t').forEach(function(b) {
      b.addEventListener('click', function() { setTimeout(onQtyChange, 10); });
    });
    // Delegated listener — covers tier buttons added/replaced after init
    document.addEventListener('click', function(e) {
      if (e.target.closest('.pp-tier-row .t, .pp-qty-btn')) setTimeout(onQtyChange, 20);
    });
    // Faster poll as a final safety net
    setInterval(function() { if (readQty() !== currentQty) onQtyChange(); }, 500);

    // ===== events =====
    openBtn.addEventListener('click', function() { openModal(); });
    // Empty stage acts as upload trigger
    stage.addEventListener('click', function(e) {
      if (stage.classList.contains('has-img')) return;
      // Ignore clicks coming from controls/overlays - only fire on the stage background
      fileInput.click();
    });
    closeBtns.forEach(function(b) { b.addEventListener('click', closeModal); });
    saveBtn.addEventListener('click', saveAndClose);
    uploadNewBtn.addEventListener('click', function() { fileInput.click(); });
    fileInput.addEventListener('change', function() {
      if (fileInput.files && fileInput.files[0]) {
        handleFile(fileInput.files[0]);
        if (!modal.classList.contains('is-open')) openModal(activeSlot);
        fileInput.value = ''; // allow re-uploading the same file
      }
    });

    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    /* Debounced commit — fires ~150ms after the user stops transforming. Calls
       commitWorkingToSlot which rebakes the active slot's thumb AND propagates
       to any duplicate sibling slots, so the strip previews update live as
       the user zooms/pans/rotates instead of only after closing the editor. */
    var commitTimer = null;
    function scheduleCommit() {
      if (commitTimer) clearTimeout(commitTimer);
      commitTimer = setTimeout(function() {
        commitTimer = null;
        commitWorkingToSlot();
      }, 150);
    }

    // Controls
    zoom.addEventListener('input', function() { working.sc = 1 + (parseInt(zoom.value, 10) / 100) * 3; applyTransform(); scheduleCommit(); });
    sat.addEventListener('input', function() { working.sat = parseInt(sat.value, 10); applyTransform(); scheduleCommit(); });
    function snapRot(delta) {
      var v = working.rot + delta;
      v = ((v % 360) + 360) % 360;
      working.rot = v;
      // Reset translate + scale so the rotated image fills the card again via cover math
      working.tx = defaults.tx;
      working.ty = defaults.ty;
      working.sc = defaults.sc;
      applyImageSize();
      applyTransform();
      if (zoomSlider) { var zp = Math.round(((working.sc - 1) / 3) * 100); zoomSlider.value = zp; if (zoomVal) zoomVal.textContent = zp + '%'; }
    }
    applyAllBtn.addEventListener('click', function() {
      commitWorkingToSlot();
      var src = slots[activeSlot];
      if (!src || !src.dataURL) return;
      // If the source slot's thumb isn't ready yet, bake it first so all copies have it
      var doCopy = function(thumbDataUrl) {
        for (var i = 0; i < currentQty; i++) {
          if (i === activeSlot) continue;
          slots[i] = {
            dataURL: src.dataURL, fileName: src.fileName,
            tx: src.tx, ty: src.ty, sc: src.sc, rot: src.rot,
            flip: src.flip, sat: src.sat,
            thumb: thumbDataUrl || src.thumb || ''
          };
        }
        renderSlots();
        updateSaveBtn();
        updateAtcBtn();
        updateTrigger();
      };
      if (src.thumb) {
        doCopy(src.thumb);
      } else {
        bakeThumb(src, function(dataUrl) {
          src.thumb = dataUrl || '';
          doCopy(src.thumb);
        });
      }
      // Brief flash feedback
      applyAllBtn.classList.add('is-flash');
      var prev = applyAllLabel.textContent;
      applyAllLabel.textContent = t('apply_all_done', { n: currentQty });
      setTimeout(function() {
        applyAllBtn.classList.remove('is-flash');
        applyAllLabel.textContent = prev;
      }, 1400);
    });

    /* Rotate and flip are discrete clicks — commit immediately rather than
       debouncing via scheduleCommit. Immediate commit guarantees the sibling
       propagation + bake runs right away, and renderSlots() then redraws the
       strip so duplicate slots show their fresh state at the next bake tick. */
    rotR.addEventListener('click', function() {
      snapRot(90);
      commitWorkingToSlot();
    });
    flipBtn.addEventListener('click', function() {
      working.flip = -working.flip;
      applyTransform();
      commitWorkingToSlot();
      renderSlots();
    });

    /* ===== quantity stepper: duplicates active design into other slots =====
       Max = tier qty − slots filled by OTHER unique images. So if 4 stickers and
       another design fills 1 slot, this design's max is 3. */
    var qtyStepper = modal.querySelector('[data-qty-stepper]');
    var qtyMinus = modal.querySelector('[data-qty-minus]');
    var qtyPlus = modal.querySelector('[data-qty-plus]');
    var qtyVal = modal.querySelector('[data-qty-current]');

    function countActiveSlotCopies() {
      var src = slots[activeSlot];
      if (!src || !src.dataURL) return 1;
      var srcSig = slotSignature(src);
      var n = 0;
      for (var i = 0; i < currentQty; i++) {
        if (slots[i] && slotSignature(slots[i]) === srcSig) n++;
      }
      return n || 1;
    }

    function countOtherFilledSlots() {
      var src = slots[activeSlot];
      var srcSig = src ? slotSignature(src) : null;
      var n = 0;
      for (var i = 0; i < currentQty; i++) {
        if (!slots[i] || !slots[i].dataURL) continue;
        var sig = slotSignature(slots[i]);
        if (sig !== srcSig) n++;
      }
      return n;
    }

    function maxForActive() {
      return Math.max(1, currentQty - countOtherFilledSlots());
    }

    function refreshQtyStepper() {
      if (!qtyStepper) return;
      var src = slots[activeSlot];
      var active = countActiveSlotCopies();
      var max = maxForActive();
      qtyVal.textContent = (src && src.dataURL) ? active : 0;
      // Minus stays enabled at active === 1 so the user can step down to 0
      // (removes the image entirely, same as the trash button).
      qtyMinus.disabled = !src || !src.dataURL;
      qtyPlus.disabled = !src || !src.dataURL || active >= max;
    }

    function applyQtyDelta(delta) {
      commitWorkingToSlot();
      var src = slots[activeSlot];
      if (!src || !src.dataURL) return;
      var current = countActiveSlotCopies();
      var max = maxForActive();
      var target = Math.max(0, Math.min(max, current + delta));
      if (target === current) return;

      /* Step-to-zero: clear the active slot AND any duplicates of it. Same
         end state as clicking the trash button — image removed, editor stage
         reset to empty, upload label flipped back to "Upload image". */
      if (target === 0) {
        var srcSig0 = slotSignature(src);
        for (var k = 0; k < currentQty; k++) {
          if (slots[k] && slotSignature(slots[k]) === srcSig0) slots[k] = null;
        }
        working = blankSlot();
        img.removeAttribute('src');
        stage.classList.add('is-empty');
        stage.classList.remove('has-img');
        uploadLabel.textContent = t('upload_image');
        renderSlots(); updateSaveBtn(); updateAtcBtn(); updateTrigger();
        refreshQtyStepper();
        return;
      }

      if (target > current) {
        // ADD copies into empty slots
        var srcSig = slotSignature(src);
        var toAdd = target - current;
        var ensureThumb = function(cb){
          if (src.thumb) return cb(src.thumb);
          bakeThumb(src, function(d){ src.thumb = d || ''; cb(src.thumb); });
        };
        ensureThumb(function(thumb){
          for (var i = 0; i < currentQty && toAdd > 0; i++) {
            if (i === activeSlot) continue;
            if (slots[i] && slots[i].dataURL) continue; // skip filled
            slots[i] = {
              dataURL: src.dataURL, fileName: src.fileName,
              tx: src.tx, ty: src.ty, sc: src.sc, rot: src.rot,
              flip: src.flip, sat: src.sat,
              thumb: thumb || src.thumb || ''
            };
            toAdd--;
          }
          renderSlots(); updateSaveBtn(); updateAtcBtn(); updateTrigger();
          refreshQtyStepper();
        });
      } else {
        // REMOVE copies (delete duplicates, leaving active slot intact)
        var toRemove = current - target;
        var srcSig2 = slotSignature(src);
        for (var j = currentQty - 1; j >= 0 && toRemove > 0; j--) {
          if (j === activeSlot) continue;
          if (slots[j] && slotSignature(slots[j]) === srcSig2) {
            slots[j] = null;
            toRemove--;
          }
        }
        renderSlots(); updateSaveBtn(); updateAtcBtn(); updateTrigger();
        refreshQtyStepper();
      }
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(){ applyQtyDelta(-1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(){ applyQtyDelta(1); });

    /* Trash: clear the active slot's design (and all duplicates of it via stepper if user wants) */
    var deleteSlotBtn = modal.querySelector('[data-delete-slot]');
    if (deleteSlotBtn) {
      deleteSlotBtn.addEventListener('click', function(){
        var src = slots[activeSlot];
        if (!src || !src.dataURL) return;
        slots[activeSlot] = null;
        // Reset working state on stage
        working = blankSlot();
        img.removeAttribute('src');
        stage.classList.add('is-empty');
        stage.classList.remove('has-img');
        /* Update the bottom upload button label immediately back to "Upload image"
           (was "Change image" while the slot had a design) */
        uploadLabel.textContent = t('upload_image');
        renderSlots();
        updateSaveBtn();
        updateAtcBtn();
        updateTrigger();
        refreshQtyStepper();
      });
    }
    resetBtn.addEventListener('click', function() {
      working.tx = defaults.tx; working.ty = defaults.ty;
      working.sc = defaults.sc; working.rot = defaults.rot;
      working.flip = defaults.flip; working.sat = defaults.sat;
      applyTransform();
      scheduleCommit();
    });

    // ===== drag pan + pinch zoom (multi-pointer) =====
    var activePointers = new Map();
    var dragStart = { sx: 0, sy: 0, tx: 0, ty: 0 };
    var pinchStart = { dist: 0, sc: 1, midX: 0, midY: 0, tx: 0, ty: 0 };

    function getRect() { return stage.getBoundingClientRect(); }

    stage.addEventListener('pointerdown', function(e) {
      if (!stage.classList.contains('has-img')) return;
      e.preventDefault();
      activePointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      try { stage.setPointerCapture(e.pointerId); } catch (_) {}

      if (activePointers.size === 1) {
        modal.classList.add('is-dragging');
        dragStart.sx = e.clientX;
        dragStart.sy = e.clientY;
        dragStart.tx = working.tx;
        dragStart.ty = working.ty;
      } else if (activePointers.size === 2) {
        var pts = Array.from(activePointers.values());
        pinchStart.dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
        pinchStart.sc = working.sc;
        pinchStart.tx = working.tx;
        pinchStart.ty = working.ty;
        pinchStart.midX = (pts[0].x + pts[1].x) / 2;
        pinchStart.midY = (pts[0].y + pts[1].y) / 2;
      }
    });

    stage.addEventListener('pointermove', function(e) {
      if (!activePointers.has(e.pointerId)) return;
      activePointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (activePointers.size === 1) {
        working.tx = dragStart.tx + (e.clientX - dragStart.sx);
        working.ty = dragStart.ty + (e.clientY - dragStart.sy);
        applyTransform();
      } else if (activePointers.size === 2) {
        var pts = Array.from(activePointers.values());
        var dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
        var midX = (pts[0].x + pts[1].x) / 2;
        var midY = (pts[0].y + pts[1].y) / 2;
        var ratio = dist / pinchStart.dist;
        working.sc = Math.max(1, Math.min(4, pinchStart.sc * ratio));
        // Two-finger pan: also follow the midpoint
        working.tx = pinchStart.tx + (midX - pinchStart.midX);
        working.ty = pinchStart.ty + (midY - pinchStart.midY);
        applyTransform();
      }
    });

    function endPointer(e) {
      if (!activePointers.has(e.pointerId)) return;
      activePointers.delete(e.pointerId);
      try { stage.releasePointerCapture(e.pointerId); } catch (_) {}
      if (activePointers.size === 0) {
        modal.classList.remove('is-dragging');
        scheduleCommit();
      } else if (activePointers.size === 1) {
        // Reset drag baseline so remaining finger keeps dragging from current position
        var rem = Array.from(activePointers.values())[0];
        dragStart.sx = rem.x;
        dragStart.sy = rem.y;
        dragStart.tx = working.tx;
        dragStart.ty = working.ty;
      }
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
    stage.addEventListener('pointerleave', endPointer);

    // Wheel zoom (desktop) - zoom toward the cursor position.
    // passive:false is REQUIRED and declared explicitly: this handler calls
    // preventDefault() so the page doesn't scroll while zooming the stage.
    stage.addEventListener('wheel', function(e) {
      if (!stage.classList.contains('has-img')) return;
      e.preventDefault();
      var rect = getRect();
      var pointerOffX = e.clientX - rect.left - rect.width / 2;
      var pointerOffY = e.clientY - rect.top - rect.height / 2;
      var prevSc = working.sc;
      var delta = e.deltaY > 0 ? -0.1 : 0.1;
      var newSc = Math.max(1, Math.min(4, prevSc + delta));
      if (newSc !== prevSc) {
        // Shift the translate so the point under the cursor stays anchored
        var k = newSc / prevSc;
        working.tx = (working.tx - pointerOffX) * k + pointerOffX;
        working.ty = (working.ty - pointerOffY) * k + pointerOffY;
        working.sc = newSc;
        applyTransform();
        scheduleCommit();
      }
    }, { passive: false });

    // Double-tap / double-click to reset zoom
    var lastTap = 0;
    stage.addEventListener('click', function() {
      var now = Date.now();
      if (now - lastTap < 320 && stage.classList.contains('has-img')) {
        working.tx = 0; working.ty = 0; working.sc = 1;
        applyTransform();
        scheduleCommit();
      }
      lastTap = now;
    });

    // Resize
    var rzTimer = null;
    window.addEventListener('resize', function() {
      if (!stage.classList.contains('has-img')) return;
      clearTimeout(rzTimer);
      rzTimer = setTimeout(function() { applyImageSize(); applyTransform(); }, 150);
    });

    // Pre-upload removed — was causing phantom cart line items to merge with
    // existing items, breaking quantities and showing wrong images. Stub kept
    // so customAddToCart's "wait for in-flight pre-upload" branch is harmless.
    var preUploadInFlight = {};

    // ===== multi-add: one line item per design (each gets its own preview image
    // in the cart). The product uses ONE variant + a hidden quantity input set to
    // the tier value (2/4/6/8). We POST N separate /cart/add.js requests with
    // quantity=1 of that same variant, each carrying ONE design's file URL as
    // a TEXT property (already pre-uploaded). Net cart: N line items × qty 1 =
    // N stickers total at correct unit price, each with its own design preview.
    function bakeP(slot, fn) { return new Promise(function(res) { fn(slot, res); }); }

    // ===== Identical-design detection =====
    // If all filled slots have the exact same upload + transforms, treat them as
    // ONE design with quantity N (single line item) instead of N separate items.
    function slotSignature(s) {
      if (!s || !s.dataURL) return null;
      // dataURL is the raw upload; transforms determine the visual outcome.
      return s.dataURL.length + ':' + s.dataURL.slice(-64) + '|' +
        s.tx.toFixed(2) + ',' + s.ty.toFixed(2) + ',' +
        s.sc.toFixed(4) + ',' + (s.rot | 0) + ',' + s.flip + ',' + (s.sat | 0);
    }
    function allDesignsIdentical() {
      var first = null;
      for (var i = 0; i < currentQty; i++) {
        var sig = slotSignature(slots[i]);
        if (!sig) return false;
        if (first === null) first = sig;
        else if (sig !== first) return false;
      }
      return true;
    }

    // Manual section injection — copies BOTH the class attribute and innerHTML,
    // because Dawn's renderContents only swaps innerHTML and leaves stale wrapper
    // classes like `is-empty` on the <cart-drawer> element. That stale class is
    // why the cart-drawer was rendering blank after adds — CSS was hiding items.
    function manualInjectSections(sectionsObj) {
      if (!sectionsObj) return false;
      var drawer = document.querySelector('cart-drawer');
      var did = false;
      var toRender = (drawer && drawer.getSectionsToRender) ? drawer.getSectionsToRender() : [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }
      ];
      toRender.forEach(function(sec) {
        var html = sectionsObj[sec.id];
        if (!html) return;
        var target = document.querySelector(sec.selector || ('#' + sec.id));
        if (!target) return;
        try {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var sourceEl = parsed.querySelector(sec.selector || ('#' + sec.id));
          if (sourceEl) {
            // CRITICAL: copy the class attribute too so stale `is-empty` wrapper
            // classes get cleared when cart goes empty → has items.
            if (sourceEl.className !== undefined) target.className = sourceEl.className;
            target.innerHTML = sourceEl.innerHTML;
            did = true;
          }
        } catch (e) {}
      });
      // Also defensively clear is-empty anywhere it shouldn't be
      var emptyCartDrawer = document.querySelector('cart-drawer.is-empty');
      if (emptyCartDrawer) emptyCartDrawer.classList.remove('is-empty');
      var emptyItems = document.querySelector('cart-drawer-items.is-empty');
      if (emptyItems) emptyItems.classList.remove('is-empty');
      return did;
    }

    // Independent header cart-badge sync straight from /cart.js. The section-render path
    // above usually updates #cart-icon-bubble, but it goes stale in some flows (the badge
    // stayed missing after add-then-close until a manual refresh). This reads the real cart
    // count and rebuilds the .cart-count-bubble to match - runs after every add and whenever
    // the drawer closes, so the header always reflects the true cart.
    function syncCartBubble() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var link = document.querySelector('#cart-icon-bubble');
          if (!link) return;
          var count = cart.item_count || 0;
          var bubble = link.querySelector('.cart-count-bubble');
          if (count > 0) {
            if (!bubble) { bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; link.appendChild(bubble); }
            bubble.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
          } else if (bubble) {
            bubble.remove();
          }
        })
        .catch(function() {});
    }
    // keep the badge honest whenever the cart drawer is closed
    document.addEventListener('click', function(e) {
      if (e.target.closest('cart-drawer .drawer__close, #CartDrawer-Overlay, [id*="Cart"] .drawer__close')) {
        setTimeout(syncCartBubble, 60);
      }
    }, true);

    // Render INSTANT optimistic line items styled exactly like real cart rows.
    // No loading spinner — the previews ARE the feedback. The real Shopify-rendered
    // HTML quietly replaces this when POSTs finish; styling is close enough that
    // the swap is barely perceptible.
    function readProductPrice() {
      // Try to grab the current variant price from the product page
      var el = document.querySelector('.price-item--sale, .price-item--regular, [data-product-price]');
      if (!el) return '';
      return (el.textContent || '').trim();
    }
    function readProductTitle() {
      var el = document.querySelector('.product__title h1, .product__title h2, h1.product-title');
      return el ? (el.textContent || '').trim() : 'Custom Sticker';
    }
    function renderOptimisticDrawer(addCalls) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      var cartIsEmpty = cartDrawer.classList.contains('is-empty');

      // STEP 1: defuse empty-cart styling if applicable
      cartDrawer.classList.remove('is-empty');
      var emptyItemsEl = cartDrawer.querySelector('cart-drawer-items.is-empty');
      if (emptyItemsEl) emptyItemsEl.classList.remove('is-empty');
      var emptyBlock = cartDrawer.querySelector('.drawer__inner-empty');
      if (emptyBlock) emptyBlock.style.display = 'none';

      var title = readProductTitle();
      var price = readProductPrice();

      // Remove any previous optimistic rows (in case user clicks ATC twice)
      cartDrawer.querySelectorAll('.ppu-optimistic, .ppu-optimistic-host').forEach(function(el) { el.remove(); });

      var rows = addCalls.map(function(c) {
        var src = c.slot.thumb || c.slot.largePreview || c.slot.dataURL || '';
        var qtyStr = c.qty > 1 ? c.qty : 1;
        return '<div class="ppu-optimistic-row" style="display:flex;align-items:center;gap:12px;padding:16px;border-bottom:1px solid #E4E4E7;font-family:Poppins,system-ui,sans-serif;background:#fff;">' +
          '<img src="' + src + '" alt="" style="width:86px;height:54px;flex:0 0 86px;object-fit:cover;border-radius:6px;box-shadow:0 1px 2px rgba(0,0,0,0.06),0 4px 12px rgba(0,0,0,0.10);" />' +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-size:14px;font-weight:700;color:#0A0A0A;line-height:1.3;">' + title + '</div>' +
            '<div style="font-size:12px;color:#6B6B70;margin-top:4px;line-height:1.2;">Qty ' + qtyStr + '</div>' +
          '</div>' +
          (price ? '<div style="font-size:14px;font-weight:700;color:#0A0A0A;white-space:nowrap;">' + price + '</div>' : '') +
        '</div>';
      }).join('');

      var optimisticHTML = '<div class="ppu-optimistic" style="padding:0;background:#fff;">' + rows + '</div>';

      if (cartIsEmpty) {
        // Empty cart: no items wrapper exists. Inject into the drawer body.
        var bodyArea = cartDrawer.querySelector('.drawer__inner') || cartDrawer;
        var holder = document.createElement('div');
        holder.className = 'ppu-optimistic-host';
        holder.innerHTML = optimisticHTML;
        bodyArea.insertBefore(holder, bodyArea.firstChild);
      } else {
        // Cart already has items — PREPEND optimistic rows ABOVE the existing
        // cart-items table so user sees their new additions on top while
        // existing items remain visible below.
        var itemsContainer = cartDrawer.querySelector('.drawer__cart-items-wrapper, cart-drawer-items');
        if (itemsContainer) {
          var holder2 = document.createElement('div');
          holder2.className = 'ppu-optimistic-host';
          holder2.innerHTML = optimisticHTML;
          itemsContainer.insertBefore(holder2, itemsContainer.firstChild);
        } else {
          var bodyArea2 = cartDrawer.querySelector('.drawer__inner') || cartDrawer;
          var holder3 = document.createElement('div');
          holder3.className = 'ppu-optimistic-host';
          holder3.innerHTML = optimisticHTML;
          bodyArea2.insertBefore(holder3, bodyArea2.firstChild);
        }
      }
    }

    function customAddToCart() {
      currentQty = readQty();
      var productForm = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
      if (!productForm) return Promise.resolve(false);
      var variantInput = productForm.querySelector('input[name="id"]');
      if (!variantInput || !variantInput.value) return Promise.resolve(false);
      // Re-resolve the variant from the Protection Layer toggle state. If the
      // customer never clicked the toggle, the variant input might still be
      // Shopify's default (without protection) even though the toggle UI shows
      // "checked". ppResolveVariant returns the correct variant id every time.
      var resolved = (typeof window.ppResolveVariant === 'function') ? window.ppResolveVariant() : null;
      var variantId = resolved || variantInput.value;
      if (resolved && variantInput.value !== String(resolved)) {
        try { variantInput.value = resolved; } catch (e) {}
      }
      var drawer = document.querySelector('cart-drawer');
      var sectionIds = drawer && drawer.getSectionsToRender
        ? drawer.getSectionsToRender().map(function(s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];

      // If all filled designs are visually identical (same upload + same
      // transforms), stack them into ONE line item with quantity N — cleaner
      // cart UX. Otherwise use N separate line items so each design's preview
      // shows. The identical check uses slotSignature defined below.
      var addCalls = [];
      var combined = allDesignsIdentical();
      if (combined) {
        addCalls.push({ slot: slots[0], qty: currentQty, idx: 0, total: 1 });
      } else {
        for (var i = 0; i < currentQty; i++) {
          if (slots[i] && slots[i].dataURL) addCalls.push({ slot: slots[i], qty: 1, idx: i, total: currentQty });
        }
      }

      // Application Kit addon (labeled "card-care" internally). Add it
      // directly here as part of our atomic chain — much more reliable than
      // the original polling script that often timed out.
      var addonRow = document.querySelector('.pp-receipt .line[data-handle="card-care"]');
      var addonChecked = addonRow && addonRow.classList.contains('checked');
      var cardCareVariantId = window.cardCareVariantId || null;
      if (!cardCareVariantId && addonRow) {
        cardCareVariantId = addonRow.getAttribute('data-variant-id');
      }
      try {
        console.log('[ppu] ATC: addon row=' + !!addonRow + ' checked=' + addonChecked + ' variantId=' + cardCareVariantId);
      } catch (e) {}

      // NO OPTIMISTIC UI — was causing the "weird first screen" that the
      // customer hated. Instead we keep the drawer CLOSED until the real cart
      // is fully ready, and show a spinner on the ATC button as feedback.
      // With Cloudinary/Edge-Function pre-uploads working, this is ~200ms total.
      // Without pre-uploads, it falls through to direct cart-add (~2s) with the
      // spinner visible — slower but clean (no flicker, no fake data).
      function openDrawerNow() {
        var d = document.querySelector('cart-drawer');
        if (!d || !d.open) return;
        try { d.open(document.querySelector('a[href="#cart"], #cart-icon-bubble') || document.body); } catch (e) {}
      }

      // STEP 1: Ensure each slot has either a Cloudinary URL (fast path) OR a
      // fresh print blob (fallback). If Cloudinary upload is still in flight
      // when ATC clicked, wait briefly for it to finish (much faster than
      // file-uploading to Shopify).
      var prepPromises = addCalls.map(function(call) {
        var s = call.slot;
        var currentSig = slotSignature(s);
        // Best case: cached Cloudinary URL matches current transforms
        if (s.uploadedURL && s.uploadSig === currentSig) {
          return Promise.resolve({ call: call, uploadedURL: s.uploadedURL });
        }
        // Ensure print blob is ready (may have to bake on-demand)
        var printP = (s.printBlob && s.printSig === currentSig)
          ? Promise.resolve(s.printBlob)
          : bakeP(s, bakeSlot).then(function(b) { s.printBlob = b; s.printSig = currentSig; return b; });
        return printP.then(function(blob) {
          // If the Supabase Edge Function proxy is configured, try uploading
          // via it now (fast path) so ATC just sends a text URL to Shopify.
          if (PPU_UPLOAD_ENABLED && blob) {
            var fname = (s.fileName || 'design').replace(/\.[^.]+$/, '') + '_' + (call.idx + 1) + '.jpg';
            return uploadDesign(blob, fname).then(function(shopifyURL) {
              s.uploadedURL = shopifyURL;
              s.uploadSig = currentSig;
              return { call: call, uploadedURL: shopifyURL };
            }).catch(function() {
              return { call: call, uploadedURL: null, printBlob: blob };
            });
          }
          return { call: call, uploadedURL: null, printBlob: blob };
        });
      });

      // STEP 2: SEQUENTIAL POSTs (parallel caused Shopify cart race conditions
      // where line items got dropped or merged). Each POST waits for the previous
      // to finish so cart state is consistent. With smaller files this is still
      // fast — and the user is already seeing the optimistic drawer.
      function postOne(it, includeSections) {
        var call = it.call;
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', String(call.qty));
        var baseName = (call.slot.fileName || 'design').replace(/\.[^.]+$/, '');
        var extMatch = (call.slot.fileName || '').match(/\.[^.]+$/);
        var origExt = extMatch ? extMatch[0].toLowerCase() : '.jpg';

        // PRINT-READY FILE: send the high-res baked image with ALL customer
        // transforms already applied (crop, rotate, zoom, saturation). The
        // manufacturer just downloads this single file and prints it as-is —
        // zero manual processing needed.
        // Quality: 2400×1508 JPEG @ 0.95 = 712 DPI on 86mm card, visually
        // indistinguishable from the original on print.
        if (it.printBlob && it.printBlob.size > 2000) {
          fd.append('properties[Custom Image]', new File([it.printBlob], baseName + '_design_' + (call.idx + 1) + '.jpg', { type: 'image/jpeg' }));
        } else if (it.uploadedURL) {
          fd.append('properties[Custom Image]', it.uploadedURL);
        } else if (call.slot.originalFile) {
          // Last resort: bake failed, ship the customer's raw upload
          var origName = (baseName || 'design') + '_original_' + (call.idx + 1) + origExt;
          fd.append('properties[Custom Image]', call.slot.originalFile, origName);
        } else if (call.slot.dataURL && call.slot.dataURL.length > 200) {
          try {
            var origFile = dataUrlToFile(call.slot.dataURL, baseName + '_original_' + (call.idx + 1) + origExt);
            if (origFile && origFile.size > 200) {
              fd.append('properties[Custom Image]', origFile);
            }
          } catch (e) {
            try { console.warn('[ppu] failed to attach fallback:', e); } catch (_) {}
          }
        }

        // _Design = "N of M" marker — only sent when designs are SEPARATE line
        // items (forces Shopify to keep them distinct). When all designs are
        // identical, we stack them into one line item with quantity N.
        if (call.total > 1) {
          fd.append('properties[_Design]', String(call.idx + 1) + ' of ' + call.total);
        }
        if (includeSections && sectionIds.length) {
          fd.append('sections', sectionIds.join(','));
          fd.append('sections_url', window.location.pathname);
        }
        return fetch('/cart/add.js', { method: 'POST', body: fd })
          .then(function(r) {
            if (!r.ok) {
              return r.json().then(function(err) { throw new Error('Shopify error: ' + (err.message || err.description || r.status)); });
            }
            return r.json();
          });
      }

      return Promise.all(prepPromises).then(function(items) {
        // FAST PATH: every slot has a Cloudinary URL → ONE atomic JSON request
        // to /cart/add.js with items[] array. All N designs added in a single
        // server round-trip. This is the Easify-speed path (~100-300ms total).
        var allHaveURL = items.every(function(it) { return !!it.uploadedURL; });
        if (allHaveURL) {
          var bodyItems = items.map(function(it) {
            return {
              id: variantId,
              quantity: it.call.qty,
              properties: {
                'Custom Image': it.uploadedURL,
                '_Design': String(it.call.idx + 1) + ' of ' + it.call.total
              }
            };
          });
          // Include the Application Kit addon in the SAME atomic request if
          // the customer has it checked. Previously the fast path skipped the
          // addon — a separate listener in product.json added it, which led
          // to "sometimes 2x" duplication. The addon is now added EXACTLY
          // ONCE here, in the same /cart/add.js call as the designs.
          if (addonChecked && cardCareVariantId) {
            bodyItems.push({ id: cardCareVariantId, quantity: 1 });
          }
          var body = {
            items: bodyItems,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          };
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function(r) {
            if (!r.ok) {
              return r.json().catch(function() { return {}; }).then(function(err) {
                throw new Error('Cart add failed: ' + (err.message || err.description || r.status));
              });
            }
            return r.json();
          });
        }

        // FALLBACK: direct file upload (no CDN). PARALLEL POSTs with retry —
        // unique `_Design` property prevents Shopify cart merging, so parallel
        // is safe. Each POST has retry-on-failure. Total time = slowest single
        // upload, not sum. For 4 designs this is ~700ms vs ~2-3s sequential.
        function postWithRetry(it, includeSections, attempt) {
          attempt = attempt || 1;
          return postOne(it, includeSections).catch(function(err) {
            if (attempt < 3) {
              try { console.warn('[ppu] post failed, retry ' + attempt, err); } catch (e) {}
              return new Promise(function(r) { setTimeout(r, 150 * attempt); })
                .then(function() { return postWithRetry(it, includeSections, attempt + 1); });
            }
            throw err;
          });
        }
        // SEQUENTIAL — Shopify cart-add responses can lag actual cart state
        // when fired concurrently (rendered sections HTML can be stale). With
        // sequential we get a clean cart state per response, and the LAST one
        // reflects the full final cart. Each post has retry on failure.
        var responses = [];
        var failures = 0;
        var chain = Promise.resolve();
        var willAddAddon = addonChecked && cardCareVariantId;
        // Progress bar denominator = the chosen sticker quantity (currentQty)
        // even if all designs are identical and stack into one cart line item.
        // Customers expect "4/4 processed" when they ordered 4 stickers.
        var designTotal = currentQty;
        var designDone = 0;
        function progress(stage) {
          var pendingBtn = document.querySelector('[aria-busy="true"]');
          if (!pendingBtn) return;
          if (stage === 'finalize') {
            setBtnProgress(pendingBtn, designTotal, designTotal);
          } else {
            setBtnProgress(pendingBtn, designDone, designTotal);
          }
        }
        progress();
        items.forEach(function(it, i) {
          var isLast = (i === items.length - 1) && !willAddAddon;
          // Combined call carries qty=N (all identical designs in one line).
          // Separate calls carry qty=1 each. Either way, advance by call.qty
          // so the bar reaches currentQty/currentQty when everything is done.
          var step = (it.call && it.call.qty) ? it.call.qty : 1;
          chain = chain.then(function() {
            return postWithRetry(it, isLast).then(function(r) {
              responses.push(r);
              designDone += step;
              progress();
            }).catch(function(err) {
              failures++;
              designDone += step;
              progress();
              try { console.error('[ppu] post permanently failed for slot', it.call.idx, err); } catch (e) {}
            });
          });
        });
        // Append the Application Kit addon as the LAST call in the chain so
        // sections data reflects the complete cart state (designs + addon).
        // We do NOT increment designDone for the addon — it's not a "design".
        if (willAddAddon) {
          chain = chain.then(function() {
            progress('finalize');
            var body = {
              items: [{ id: cardCareVariantId, quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname
            };
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(body)
            })
              .then(function(r) { return r.json(); })
              .then(function(r) { responses.push(r); })
              .catch(function(err) {
                try { console.warn('[ppu] application kit add failed', err); } catch (e) {}
              });
          });
        }
        return chain.then(function() {
          if (responses.length === 0) throw new Error('All cart adds failed');
          if (failures > 0) {
            try { console.warn('[ppu] ' + failures + '/' + items.length + ' designs failed to add'); } catch (e) {}
          }
          return responses[responses.length - 1];
        });
      }).then(function(lastResponse) {
        // STEP 3: inject the real Shopify-rendered cart HTML, then open drawer.
        var rendered = false;
        if (lastResponse && lastResponse.sections) {
          rendered = manualInjectSections(lastResponse.sections);
        }
        if (!rendered) {
          // Fallback: fetch sections directly
          return fetch('/cart?sections=' + sectionIds.join(',') + '&sections_url=' + window.location.pathname)
            .then(function(r) { return r.json(); })
            .then(function(sectionsObj) {
              if (manualInjectSections(sectionsObj)) {
                openDrawerNow();
                syncCartBubble();
              } else {
                window.location.href = '/cart';
              }
            })
            .catch(function() { window.location.href = '/cart'; });
        }
        openDrawerNow();
        syncCartBubble();
      }).catch(function(err) {
        try { console.error('[ppu] add-to-cart failed', err); } catch (e) {}
        // Restore drawer state and surface the error
        setError(t('err_atc_failed'));
        // Hard-refresh the drawer so the optimistic placeholders don't linger
        fetch('/cart?sections=' + sectionIds.join(',') + '&sections_url=' + window.location.pathname)
          .then(function(r) { return r.json(); })
          .then(function(sectionsObj) { manualInjectSections(sectionsObj); })
          .catch(function() {});
      });
    }

    // ===== ATC intercept: capture-phase listeners on BOTH click and submit so we
    // catch button clicks AND keyboard-Enter submits before Dawn's product-form
    // handler runs. We do NOT scope by `root.closest(form)` because our .ppu
    // block is a sibling of the buy-buttons block (not inside the form).
    var atcSubmitting = false;
    function isOurProductForm(form) {
      if (!form) return false;
      // Only intercept the buy-buttons form on the product page where our snippet exists
      if (!document.getElementById('ppu-main')) return false;
      var action = form.getAttribute('action') || '';
      return action.indexOf('/cart/add') !== -1;
    }
    function setBtnLoading(btn, on) {
      if (!btn) return;
      if (on) {
        if (!btn.hasAttribute('data-ppu-orig-html')) btn.setAttribute('data-ppu-orig-html', btn.innerHTML);
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        /* Two-row layout: status text on top, progress bar underneath.
           The bar's width is animated continuously by setBtnCreep so customers
           always see motion — discrete step updates (setBtnProgress) jump it
           forward to the new target. */
        btn.innerHTML =
          '<span class="ppu-load" style="display:flex;flex-direction:column;align-items:stretch;justify-content:center;gap:6px;width:100%;padding:2px 14px;">' +
            '<span class="ppu-load__label" style="text-align:center;font-weight:700;letter-spacing:0.04em;line-height:1.1;">' + t('processing_label') + '</span>' +
            '<span class="ppu-load__track" style="position:relative;height:5px;width:100%;background:rgba(255,255,255,0.18);border-radius:3px;overflow:hidden;">' +
              '<span class="ppu-load__bar" style="display:block;height:100%;width:2%;background:#FFFFFF;border-radius:3px;transition:width 0.4s cubic-bezier(.2,.7,.2,1);"></span>' +
            '</span>' +
          '</span>';
        // Reset creep state and kick off the continuous fill loop
        btn.__ppCreep = { target: 0.02, current: 0.02, timer: null };
        startBtnCreep(btn);
      } else {
        stopBtnCreep(btn);
        var orig = btn.getAttribute('data-ppu-orig-html');
        if (orig != null) {
          btn.innerHTML = orig;
          btn.removeAttribute('data-ppu-orig-html');
        }
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
    function startBtnCreep(btn) {
      stopBtnCreep(btn);
      btn.__ppCreep.timer = setInterval(function() {
        var bar = btn.querySelector('.ppu-load__bar');
        if (!bar || !btn.__ppCreep) return;
        var st = btn.__ppCreep;
        // Bar ALWAYS drifts upward toward 95% with exponential decay, so the
        // customer always sees motion even when a step is taking a while.
        // setBtnProgress snaps us forward when real progress lands; we never
        // reach 100% via creep alone — only via the 'finalize' stage.
        var ceiling = 0.95;
        if (st.current < ceiling) {
          var gap = ceiling - st.current;
          st.current = Math.min(ceiling, st.current + Math.max(gap * 0.018, 0.004));
          bar.style.width = (st.current * 100).toFixed(2) + '%';
        }
      }, 200);
    }
    function stopBtnCreep(btn) {
      if (btn && btn.__ppCreep && btn.__ppCreep.timer) {
        clearInterval(btn.__ppCreep.timer);
        btn.__ppCreep.timer = null;
      }
    }
    function setBtnProgress(btn, done, total) {
      if (!btn) return;
      var bar = btn.querySelector('.ppu-load__bar');
      var label = btn.querySelector('.ppu-load__label');
      if (!bar || !label) return;
      var frac = total > 0 ? Math.min(1, done / total) : 0;
      if (btn.__ppCreep) {
        // Snap forward only — never reverse. Creep continues from here toward 95%.
        if (frac > btn.__ppCreep.current) {
          btn.__ppCreep.current = frac;
          bar.style.width = (frac * 100).toFixed(2) + '%';
        }
      } else {
        bar.style.width = Math.max(Math.round(frac * 100), 2) + '%';
      }
      if (frac >= 1) {
        label.textContent = t('almost_done');
        if (btn.__ppCreep) btn.__ppCreep.current = 1;
        bar.style.width = '100%';
      } else {
        label.textContent = t('processing_with_count', { done: done, total: total });
      }
    }

    function runHijack(e, btn) {
      currentQty = readQty();
      if (countFilled() < currentQty) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // Show error inline near the upload widget — do NOT auto-open the
        // modal. Auto-opening surprised customers who didn't know what to do.
        setError(t('err_designs_required'));
        return;
      }
      // preventDefault + stopImmediatePropagation together block BOTH the
      // form's default submit AND every other click listener attached to the
      // ATC button — including Shopify's product-form custom element which
      // otherwise fires its OWN /cart/add.js request in parallel and produces
      // the "doubled cart items" + "2x application kit" bug. Our own addon
      // logic (card-care) is handled internally below, so we don't need any
      // other listener to run on this click.
      e.preventDefault();
      e.stopImmediatePropagation();
      if (atcSubmitting) return;
      atcSubmitting = true;
      // Spinner on the button while uploads run. Drawer stays closed until
      // real cart is ready — no more "weird first screen" with fake data.
      if (btn) setBtnLoading(btn, true);
      // Hard safety net: 15s timeout navigates to /cart in genuine failure cases.
      var timeoutId = setTimeout(function() {
        try { console.warn('[ppu] add-to-cart timeout — navigating to /cart'); } catch (e) {}
        window.location.href = '/cart';
      }, 15000);
      // Expose the upload promise globally so the Checkout-button interceptor
      // can await it if the customer races through to checkout before uploads
      // finish. This is the "defer wait to checkout transition" UX trick —
      // ATC feels instant, the actual wait happens during checkout transition
      // where customers naturally expect a brief loading state.
      var atcPromise = customAddToCart();
      window.PPU_ATC_PENDING = atcPromise;
      atcPromise.catch(function() {}).then(function() {
        clearTimeout(timeoutId);
        atcSubmitting = false;
        if (btn) setBtnLoading(btn, false);
        if (window.PPU_ATC_PENDING === atcPromise) window.PPU_ATC_PENDING = null;
      });
    }
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart]');
      if (!btn) return;
      var form = btn.closest('form[action*="/cart/add"]');
      if (!isOurProductForm(form)) return;
      runHijack(e, btn);
    }, true);
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!isOurProductForm(form)) return;
      runHijack(e, form.querySelector('[name="add"], .product-form__submit, [type="submit"]'));
    }, true);

    // ===== product image gallery preview swap (swipeable, multi-design) =====
    // After slots are saved, REPLACE the product media gallery's images with each
    // customer's design (1 per slot) so the gallery becomes swipeable previews of
    // the actual cards they're buying. The original Dawn gallery markup, swipe,
    // and thumbnails all keep working — we just substitute the <img> sources.
    // Strategy: mount a self-contained swipeable overlay inside the first product
    // media item. Hide Dawn's other slides + thumbnail dock while designs exist.
    // Cleared slots → remove overlay + restore Dawn's gallery.
    var GALLERY_STYLE_ID = 'pp-gallery-styles';
    function ensureGalleryStyles() {
      if (document.getElementById(GALLERY_STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = GALLERY_STYLE_ID;
      s.textContent = [
        /* Confine the carousel to its own stacking context so it can't bleed
           across Dawn's drawer overlays. */
        /* Carousel is contained inside the gallery — overflow stays hidden so iOS
           Safari renders the absolutely-positioned child correctly. The shadow
           is sized to fit within the carousel padding instead of bleeding out. */
        '.pp-design-host { isolation: isolate; }',
        '.pp-design-carousel { position:absolute; inset:0; display:flex; align-items:center; justify-content:center; background:#FFFFFF; z-index:1; padding:0; box-sizing:border-box; overflow:hidden; cursor:grab; user-select:none; }',
        '.pp-design-carousel.is-dragging { cursor:grabbing; }',
        '.pp-design-carousel__track { width:100%; height:100%; display:flex; transition:transform 0.42s cubic-bezier(0.22, 1, 0.36, 1); will-change:transform; }',
        '.pp-design-carousel.is-dragging .pp-design-carousel__track { transition:none; }',
        /* Each slide is 100% wide with inner horizontal padding — the padding
           is the visible spacing between cards while keeping go(n) math simple. */
        '.pp-design-carousel__slide { flex:0 0 100%; height:100%; display:flex; align-items:center; justify-content:center; padding:12% 18%; box-sizing:border-box; }',
        /* Softer shadow that fades naturally — using larger blur + lower opacity
           so the edge dissolves on iOS where overflow visible is risky. */
        '.pp-design-card { width:100%; aspect-ratio: 86 / 54; max-height:100%; border-radius:3.7%; overflow:hidden; background:#FFF; box-shadow: 0 24px 40px -16px rgba(0,0,0,0.12), 0 10px 20px -10px rgba(0,0,0,0.06); position:relative; pointer-events:none; }',
        '.pp-design-card img { width:100%; height:100%; object-fit:cover; display:block; pointer-events:none; }',
        '.pp-design-card__chip { position:absolute; left:12.85%; top:36.77%; width:12.9%; height:16.7%; background:#FFFFFF; border-radius:14% / 12%; pointer-events:none; }',
        /* Product-photo slides (the normal marketing images) live in the same carousel as
           the design cards so the gallery shows BOTH. They fill the square edge-to-edge like
           a normal gallery image instead of rendering as a card. */
        '.pp-design-carousel__slide--photo { padding:0 !important; }',
        '.pp-design-carousel__slide--photo img { width:100%; height:100%; object-fit:cover; display:block; pointer-events:none; }',
        '.pp-design-carousel__dots { position:absolute; bottom:14px; left:50%; transform:translateX(-50%); display:flex; gap:7px; z-index:6; }',
        '.pp-design-carousel__dot { width:7px; height:7px; border-radius:50%; background:rgba(10,10,10,0.25); border:none; padding:0; cursor:pointer; transition:background 0.15s, transform 0.15s; }',
        '.pp-design-carousel__dot.is-active { background:#0A0A0A; transform:scale(1.3); }',
        '.pp-design-carousel[data-count="1"] .pp-design-carousel__dots { display:none; }',
        '.pp-design-carousel--touch { touch-action: pan-y; }',
        'media-gallery.pp-has-designs .product__media-item:not(.pp-design-host) { display:none !important; }',
        'media-gallery.pp-has-designs .thumbnail-list { display:none !important; }',
        /* Mount the carousel INSIDE the rounded .product-media-container (not the bare slide),
           so it inherits the exact same framing as a normal gallery image: the slide's side
           padding gives the inset (not edge-to-edge full width), the container's border-radius
           gives the rounded corners, and padding-top:100% forces a clean 1:1 square on every
           viewport (desktop already squares this way; this extends it to mobile so square
           product photos are never cropped). The container's own image/opener is hidden so
           only the carousel shows. */
        'media-gallery.pp-has-designs .pp-design-host .product-media-container { padding-top:100% !important; height:0 !important; position:relative !important; border-radius:16px !important; overflow:hidden !important; }',
        'media-gallery.pp-has-designs .pp-design-host .product-media-container > *:not(.pp-design-carousel) { display:none !important; }',
        /* photo slides host their own benefit bar (absolute, top) like the normal gallery */
        '.pp-design-carousel__slide--photo { position:relative; }'
      ].join('\n');
      document.head.appendChild(s);
    }
    function getGalleryHost() {
      var gallery = document.querySelector('media-gallery');
      if (!gallery) return null;
      var firstItem = gallery.querySelector('.product__media-item, .product-media-container');
      if (!firstItem) firstItem = gallery.querySelector('li, [data-media-id]');
      return firstItem ? { gallery: gallery, host: firstItem } : null;
    }
    // items: [{ src, type }] where type is 'design' (rendered as a card + chip) or
    // 'product' (rendered as a full-bleed photo, i.e. the normal marketing gallery images).
    // Both live in the same carousel so the gallery shows the customer's designs AND the
    // product photos, all navigated by our shared .pp-dots.
    function buildCarousel(items, sectionId) {
      var car = document.createElement('div');
      car.className = 'pp-design-carousel pp-design-carousel--touch';
      car.setAttribute('data-count', items.length);
      // Force the overlay to actually fill the gallery square. The injected stylesheet
      // rule (position:absolute;inset:0) was being out-specificity'd and computed to
      // position:relative, so the carousel collapsed to its content height (~212px) and
      // left a big gap in the square. Inline styles always win, so pin it here.
      car.style.position = 'absolute';
      // Extend ~2px beyond the container on the left/right so the container's rounded
      // overflow:hidden clips the sub-pixel edge bleed of the adjacent (clone) slide - that
      // faint vertical "streifen" of the neighbouring image at the very edge. The images are
      // object-fit:cover so the 2px overscan is invisible.
      car.style.top = '0'; car.style.left = '-2px'; car.style.right = '-2px'; car.style.bottom = '0';
      var track = document.createElement('div');
      track.className = 'pp-design-carousel__track';
      items.forEach(function(item) {
        var slide = document.createElement('div');
        slide.className = 'pp-design-carousel__slide';
        if (item.type === 'product') {
          slide.className += ' pp-design-carousel__slide--photo';
          var pim = document.createElement('img');
          pim.src = item.src; pim.alt = '';
          slide.appendChild(pim);
          if (item.benefitHTML) {
            var wrap = document.createElement('div');
            wrap.innerHTML = item.benefitHTML;
            if (wrap.firstElementChild) slide.appendChild(wrap.firstElementChild);
          }
        } else {
          var card = document.createElement('div');
          card.className = 'pp-design-card';
          var im = document.createElement('img');
          im.src = item.src; im.alt = '';
          card.appendChild(im);
          var chip = document.createElement('div');
          chip.className = 'pp-design-card__chip';
          card.appendChild(chip);
          slide.appendChild(card);
        }
        track.appendChild(slide);
      });

      // Bidirectional seamless infinite wrap (same trick as the normal gallery, both ways):
      // prepend a clone of the LAST slide before the first, and append a clone of the FIRST
      // slide after the last. Swiping forward past the last real slide animates onto the
      // trailing first-clone (looks like slide 0) then snaps to the real first; swiping
      // backward before the first animates onto the leading last-clone (looks like the last
      // slide) then snaps to the real last. Either way it reads as a normal continuous swipe.
      var count = items.length;
      var hasWrap = count > 1;
      // With a prepended clone, real slide i sits at track position i + offset.
      var offset = hasWrap ? 1 : 0;
      if (hasWrap) {
        var firstClone = track.firstElementChild.cloneNode(true);
        firstClone.setAttribute('aria-hidden', 'true');
        firstClone.setAttribute('data-pp-carousel-clone', '1');
        var lastClone = track.lastElementChild.cloneNode(true);
        lastClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('data-pp-carousel-clone', '1');
        track.appendChild(firstClone);                              // track pos count+1
        track.insertBefore(lastClone, track.firstElementChild);     // track pos 0
      }
      car.appendChild(track);

      var idx = 0;
      var setActive = null;
      function applyTransform(pos, animate) {
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translateX(' + (-pos * 100) + '%)';
      }
      function settle(pos) {           // instant (no-animation) reset to a real track position
        applyTransform(pos, false);
        void track.offsetWidth;        // flush so the next move animates again
        track.style.transition = '';
      }
      function go(n) {
        if (!hasWrap) {
          idx = Math.max(0, Math.min(count - 1, n));
          applyTransform(idx, true);
          if (setActive) setActive(idx);
          return;
        }
        if (n >= count) {
          applyTransform(count + 1, true);           // animate onto trailing first-clone
          idx = 0; if (setActive) setActive(0);
          var onEndF = function () { track.removeEventListener('transitionend', onEndF); settle(offset); };
          track.addEventListener('transitionend', onEndF);
        } else if (n < 0) {
          applyTransform(0, true);                    // animate onto leading last-clone
          idx = count - 1; if (setActive) setActive(count - 1);
          var onEndB = function () { track.removeEventListener('transitionend', onEndB); settle(count); };
          track.addEventListener('transitionend', onEndB);
        } else {
          idx = n; applyTransform(n + offset, true);
          if (setActive) setActive(n);
        }
      }
      // seat the initial position on the real first slide (past the leading clone)
      settle(offset);

      // Integrate into OUR gallery dots (window.ppGalleryDots) instead of shipping a
      // second dot row. The product page exposes setDesignMode(count, onDotClick) which
      // rebuilds the real .pp-dots to `count` and returns a setActive(idx) we call from
      // go(). Falls back to the carousel's own dots only if that hook isn't present.
      var api = sectionId && window.ppGalleryDots && window.ppGalleryDots[sectionId];
      if (api && typeof api.setDesignMode === 'function') {
        setActive = api.setDesignMode(items.length, go);
      } else if (items.length > 1) {
        var dots = document.createElement('div');
        dots.className = 'pp-design-carousel__dots';
        for (var i = 0; i < items.length; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'pp-design-carousel__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('data-idx', i);
          d.setAttribute('aria-label', 'Design ' + (i + 1));
          dots.appendChild(d);
        }
        car.appendChild(dots);
        setActive = function(activeIdx){
          var dotEls = dots.children;
          for (var k = 0; k < dotEls.length; k++) dotEls[k].classList.toggle('is-active', k === activeIdx);
        };
        dots.addEventListener('click', function(e) {
          var t = e.target.closest('.pp-design-carousel__dot');
          if (!t) return;
          e.preventDefault(); e.stopPropagation();
          go(parseInt(t.getAttribute('data-idx'), 10) || 0);
        });
      }

      if (items.length > 1) {
        // Pointer-based swipe — works for mouse drag, touch, and stylus. Best-practice
        // gesture handling to kill the "swipe a bit, snaps back" feel:
        //  - one-time AXIS LOCK after an 8px deadzone: once the gesture is horizontal it
        //    stays horizontal (no mid-swipe abandon on a slightly diagonal drag); once it's
        //    vertical we bail immediately so the page scrolls.
        //  - VELOCITY / FLICK detection: a fast flick advances even if it never crossed the
        //    distance threshold, so a quick short swipe never rubber-bands back.
        //  - release animates continuously from the exact dragged position to the target.
        var startX = 0, startY = 0, dx = 0, dragging = false, pointerId = null;
        var lastX = 0, lastT = 0, velocity = 0, axis = 0; // axis: 0 undecided, 1 horizontal, -1 vertical
        car.addEventListener('pointerdown', function(e) {
          if (e.target.closest('.pp-dots__dot, .pp-design-carousel__dot')) return; // let dot clicks through
          dragging = true; pointerId = e.pointerId;
          startX = e.clientX; startY = e.clientY; dx = 0;
          lastX = e.clientX; lastT = Date.now(); velocity = 0; axis = 0;
          car.classList.add('is-dragging');
          try { car.setPointerCapture(e.pointerId); } catch (_) {}
        });
        car.addEventListener('pointermove', function(e) {
          if (!dragging || e.pointerId !== pointerId) return;
          dx = e.clientX - startX;
          var dy = e.clientY - startY;
          if (axis === 0) {                       // decide the axis once, after an 8px deadzone
            if (Math.abs(dx) > 8 || Math.abs(dy) > 8) axis = Math.abs(dx) >= Math.abs(dy) ? 1 : -1;
          }
          if (axis === -1) {                      // vertical -> hand the gesture back to the page
            dragging = false;
            car.classList.remove('is-dragging');
            try { car.releasePointerCapture(e.pointerId); } catch (_) {}
            go(idx);
            return;
          }
          if (axis !== 1) return;                 // not committed to horizontal yet
          if (e.cancelable) e.preventDefault();   // we own the horizontal gesture now
          var now = Date.now();
          if (now > lastT) { velocity = (e.clientX - lastX) / (now - lastT); lastX = e.clientX; lastT = now; }
          track.style.transform = 'translateX(calc(' + (-(idx + offset) * 100) + '% + ' + dx + 'px))';
        });
        function endDrag(e) {
          if (!dragging || (pointerId != null && e && e.pointerId !== pointerId)) return;
          dragging = false;
          car.classList.remove('is-dragging');
          try { if (pointerId != null) car.releasePointerCapture(pointerId); } catch (_) {}
          var distThreshold = car.clientWidth * 0.14;
          var flick = Math.abs(velocity) > 0.3;   // px/ms - a deliberate flick
          if (dx < -distThreshold || (flick && velocity < 0)) go(idx + 1);
          else if (dx > distThreshold || (flick && velocity > 0)) go(idx - 1);
          else go(idx);
          dx = 0; pointerId = null; velocity = 0; axis = 0;
        }
        car.addEventListener('pointerup', endDrag);
        car.addEventListener('pointercancel', endDrag);
        car.addEventListener('pointerleave', endDrag);
      }
      return car;
    }
    function updateGalleryPreview() {
      ensureGalleryStyles();
      var g = getGalleryHost();
      if (!g) return;
      var thumbs = [];
      for (var i = 0; i < currentQty; i++) {
        var s = slots[i];
        if (s && (s.largePreview || s.thumb || s.dataURL)) {
          thumbs.push(s.largePreview || s.thumb || s.dataURL);
        }
      }
      // section id drives which product gallery's dots we integrate with
      var sectionId = (g.gallery.id || '').replace(/^MediaGallery-/, '');
      var dotsApi = sectionId && window.ppGalleryDots && window.ppGalleryDots[sectionId];
      var existing = g.gallery.querySelector('.pp-design-carousel');
      var productImgs = collectProductImages(g.gallery);
      // Only bail to the native gallery if there is genuinely nothing to show. Otherwise we
      // ALWAYS render the carousel (product images always; designs prepended when present) so
      // the no-upload gallery uses the exact same clean transform-swipe + wrap as the upload
      // state - which the owner preferred over the native scroll gallery.
      if (!thumbs.length && !productImgs.length) {
        if (existing) existing.remove();
        g.gallery.classList.remove('pp-has-designs');
        var host = g.gallery.querySelector('.pp-design-host');
        if (host) host.classList.remove('pp-design-host');
        if (dotsApi && typeof dotsApi.clearDesignMode === 'function') dotsApi.clearDesignMode();
        return;
      }
      // Build only once the dots API exists, so the carousel drives OUR .pp-dots rather than
      // falling back to its own dot row (the API is set by main-product.liquid's inline script).
      if (!dotsApi || typeof dotsApi.setDesignMode !== 'function') return;
      g.gallery.classList.add('pp-has-designs');
      g.host.classList.add('pp-design-host');
      var cs = window.getComputedStyle(g.host);
      if (cs.position === 'static') g.host.style.position = 'relative';
      // Build the combined slide list: the real product marketing photos FIRST, then the
      // customer's design cards, so the gallery opens on the product exactly as it does
      // before any upload, with the designs following under our shared dots.
      var items = productImgs.map(function(p){ return { src: p.src, type: 'product', benefitHTML: p.benefitHTML }; });
      thumbs.forEach(function(src){ items.push({ src: src, type: 'design' }); });
      var fresh = buildCarousel(items, sectionId);
      // Mount inside the rounded, inset .product-media-container so it's framed like a
      // normal gallery image (not edge-to-edge), falling back to the slide itself.
      var mount = g.host.querySelector('.product-media-container') || g.host;
      if (existing) existing.replaceWith(fresh);
      else mount.appendChild(fresh);
    }
    // The original product marketing images, read straight off the (now visually-hidden)
    // gallery slides so they can ride along in the design carousel. The design-host slide's
    // own <img> still points at product image #1, so this returns the full original set.
    function collectProductImages(gallery) {
      var slider = gallery.querySelector('[id^="Slider-Gallery-"]');
      if (!slider) return [];
      var slides = Array.prototype.slice.call(
        slider.querySelectorAll('.product__media-item:not([data-pp-clone])')
      );
      var out = [];
      slides.forEach(function(s) {
        var img = s.querySelector('img');
        if (!img) return;
        var u = img.getAttribute('src') || img.currentSrc || '';
        if (!u) return;
        // carry the slide's benefit bar (Pay as before / Fits your card / ...) so the photo
        // keeps its label in the carousel exactly like the normal gallery. The black
        // "Custom_Sticker" card has no real benefit of its own (any bar on it is a stray from
        // the re-parent pass), so never carry a label for it.
        var isBlackCard = /custom[_-]?sticker/i.test(u);
        var benefit = isBlackCard ? null : s.querySelector('.pp-benefit');
        out.push({ src: u, benefitHTML: benefit ? benefit.outerHTML : '' });
      });
      return out;
    }
    var lastGallerySig = '';
    setInterval(function() {
      var sig = '';
      for (var i = 0; i < currentQty; i++) {
        var s = slots[i];
        var key = s && (s.largePreview || s.thumb) ? (s.largePreview || s.thumb).slice(-32) : '_';
        sig += key + '|';
      }
      sig += '#' + currentQty;
      // Rebuild on any design change, AND keep retrying while the carousel hasn't been built
      // yet - on first load the dots API / product <img> src may not be ready on the first
      // tick, and since the no-design signature never changes we'd otherwise never build it.
      var needsBuild = !document.querySelector('.pp-design-carousel');
      if (sig !== lastGallerySig || needsBuild) {
        lastGallerySig = sig;
        updateGalleryPreview();
      }
    }, 400);
    // build immediately too, so the native gallery doesn't flash before the carousel mounts
    updateGalleryPreview();

    // ===== iOS viewport fix: track visualViewport so the modal never sits behind the bottom toolbar =====
    function syncViewportHeight() {
      var h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      modal.style.setProperty('--ppu-vh', h + 'px');
    }
    syncViewportHeight();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncViewportHeight);
      window.visualViewport.addEventListener('scroll', syncViewportHeight);
    }
    window.addEventListener('resize', syncViewportHeight);
    window.addEventListener('orientationchange', function() { setTimeout(syncViewportHeight, 200); });

    // ===== persistence across page refresh =====
    // localStorage = small metadata + large preview JPEGs (~150-200KB each).
    // IndexedDB = full original uploads (can be multi-MB) for high-quality print bakes.
    var STORAGE_KEY = 'ppu_slots_v1';
    var IDB_NAME = 'ppu_db_v1';
    var IDB_STORE = 'uploads';
    var productKey = (document.querySelector('meta[property="og:url"]') && document.querySelector('meta[property="og:url"]').content)
      || (window.location.pathname.split('?')[0]);

    function openIDB() {
      return new Promise(function(resolve) {
        try {
          var req = indexedDB.open(IDB_NAME, 1);
          req.onupgradeneeded = function() {
            var db = req.result;
            if (!db.objectStoreNames.contains(IDB_STORE)) db.createObjectStore(IDB_STORE);
          };
          req.onsuccess = function() { resolve(req.result); };
          req.onerror = function() { resolve(null); };
        } catch (e) { resolve(null); }
      });
    }
    function idbPut(key, value) {
      return openIDB().then(function(db) {
        if (!db) return;
        return new Promise(function(resolve) {
          try {
            var tx = db.transaction(IDB_STORE, 'readwrite');
            tx.objectStore(IDB_STORE).put(value, key);
            tx.oncomplete = function() { resolve(true); };
            tx.onerror = function() { resolve(false); };
          } catch (e) { resolve(false); }
        });
      });
    }
    function idbGet(key) {
      return openIDB().then(function(db) {
        if (!db) return null;
        return new Promise(function(resolve) {
          try {
            var tx = db.transaction(IDB_STORE, 'readonly');
            var req = tx.objectStore(IDB_STORE).get(key);
            req.onsuccess = function() { resolve(req.result || null); };
            req.onerror = function() { resolve(null); };
          } catch (e) { resolve(null); }
        });
      });
    }

    function persistSlots() {
      try {
        var snapshot = slots.map(function(s, i) {
          if (!s || !s.dataURL) return null;
          return {
            i: i,
            fileName: s.fileName,
            tx: s.tx, ty: s.ty, sc: s.sc, rot: s.rot, flip: s.flip, sat: s.sat,
            thumb: s.thumb || '',
            largePreview: s.largePreview || ''
          };
        });
        var payload = { productKey: productKey, qty: currentQty, slots: snapshot, ts: Date.now() };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) { /* quota or serialization failure — ignore */ }

      // Save full upload data to IDB (async, fire-and-forget)
      slots.forEach(function(s, i) {
        if (s && s.dataURL) idbPut(productKey + ':' + i, s.dataURL);
      });
    }

    var persistTimer = null;
    function schedulePersist() {
      clearTimeout(persistTimer);
      persistTimer = setTimeout(persistSlots, 300);
    }

    function restoreSlots() {
      var raw;
      try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) { return; }
      if (!raw) return;
      var data;
      try { data = JSON.parse(raw); } catch (e) { return; }
      if (!data || data.productKey !== productKey || !Array.isArray(data.slots)) return;

      // Restore metadata + preview thumbs immediately so UI looks complete
      data.slots.forEach(function(snap) {
        if (!snap) return;
        slots[snap.i] = {
          dataURL: snap.largePreview || snap.thumb || '', // placeholder until IDB resolves
          fileName: snap.fileName || '',
          tx: snap.tx, ty: snap.ty, sc: snap.sc, rot: snap.rot, flip: snap.flip, sat: snap.sat,
          thumb: snap.thumb || '',
          largePreview: snap.largePreview || ''
        };
      });
      // Replace placeholder dataURL with the real original upload from IDB
      data.slots.forEach(function(snap) {
        if (!snap) return;
        idbGet(productKey + ':' + snap.i).then(function(full) {
          if (full && slots[snap.i]) {
            slots[snap.i].dataURL = full;
          }
        });
      });
      updateTrigger();
      updateAtcBtn();
      // Trigger gallery refresh via the existing interval (sig will differ → updateGalleryPreview fires)
    }

    // Auto-persist on every state change. The lightweight approach: wrap
    // commitWorkingToSlot and bakeAndUpdateInputs to schedule a save afterward.
    var origCommit = commitWorkingToSlot;
    commitWorkingToSlot = function() { var r = origCommit.apply(this, arguments); schedulePersist(); return r; };
    var origBake = bakeAndUpdateInputs;
    bakeAndUpdateInputs = function() { var r = origBake.apply(this, arguments); schedulePersist(); return r; };

    // ===== init =====
    ensureCartInputs();
    restoreSlots();
    updateTrigger();
    updateAtcBtn();

    // Easify is now the upload + ATC backend. We no longer kill its UI.
  })();
